module.exports = {
  BusinessNo: '业务编号',
  WarehouseNo: '进仓编号',
  MasterBillNo: '主单号',
  HBL: 'HBL',
  FileNo: '文件编号',
  BookingNo: 'S/O No.',
  ItemNo: '项目编号',
  BusinessReferenceNo: '业务参考号',
  BillNo: '账单号',
  PreBookingNo: '预订舱号码',
  CBANumber: '报关委托编号',
  CustomsStatus: '海关状态',
  CustomsStatusUpdateTime: '海关状态更新时间',
  ReceiptDetails: '回执明细',
  CustomsBrokerStatus: '报关行状态',
  CustomsReceiptRecord: '海关回执记录',
  CustomsTime: '海关时间',
  CustomsCode2: '海关编码',
  CustomsDescription: '海关描述',
  UnifiedCoding: '统一编码',
  HBLSplitCombineNo: 'HBL分并单号',
  MBLSplitCombineNo: 'MBL分并单号',
  ConsignationCompany: '委托单位',
  BookingAgent: '订舱代理',
  BookingOrExchangeAgent: '订舱代理/换单代理',
  CarrierAgent: '船代',
  DestinationAgent: '目的港代理',
  ShippingCompany: '船公司',
  OperateCarrier: '主船公司',
  VSACarrier: '共舱船公司',
  InternalVoy: '内部航次',
  CopyShip: '复制主船东信息到共舱船东',
  ContainerNo: '箱号',
  BoxController: '控箱人',
  LFD: 'LFD',
  CarNumber: '车皮号',
  ContainerNoOutOfRange: '箱号长度超过限制',
  PortOfLoading: '起运港(POL)',
  PortOfLoadingPOR: '起运港(POR)',
  TransitPort: '中转港',
  PortOfDestination: '目的港',
  PortOfDestinationPod: '目的港(POD)',
  PortOfDischarge: '卸货港(POD)',
  PortOfDischargeSeaAndComprehensive: '卸货港(海运/综合)',
  DischargingPortCountry: '卸货港国家/地区',
  DestinationPortCountry: '目的港国家/地区',
  dischargingPort: '卸货港',
  FirstPortOfDischarge: '一卸货港',
  branchLineDateOfDeparture: '支线开航日期',
  branchLineDateOfArrival: '支线到港日期',
  DateOfDeparture: '开航日期',
  DateOfDeparture2: '开航日期(ETD)',
  BookingDate: '订舱日期',
  BargeDateOfDeparture: '驳船开航日期',
  BargeCYCutOffDate2: '驳船截关日期',
  BargePortOfLoading: '驳船起运港(POL)',
  BargeVessel: '驳船船名',
  BargeVoyage: '驳船航次',
  BargePOL: '驳船POL',
  SecondDateOfDeparture: '二程开航日期',
  DeliveryCompletionDate: '送货完成时间',
  DateOfArrival: '到港日期',
  DateOfArrival2: '到港日期(ETA)',
  DateOfArrival3: 'ETA',
  DateOfCreation: '创建日期',
  CYCutOffDate2: '截关日期',
  DocCutOffDate: '截单日期',
  DeclareCutOffDate: '截申报日期',
  LoadingDate: '装箱日期',
  PreAuditTime: '预审审核时间',
  CallSignOfBookingShip: '订舱船舶呼号',
  MasterBLFreightTerm: '主单运费条款',
  MasterBLFreightTermTootip: '主单运费条款',
  OrderChannels: '订单渠道',
  CargoType: '货物类型',
  Shipper: '发货人',
  ShipperCode: '发货人code',
  Consignee: '收货人',
  ConsigneeCode: '收货人code',
  SONO: '加拼单号',
  ShippingCompanyContractNo: '船公司约号',
  PleaseEnterTheShippingCompanyContractNumber: '请输入船公司约号',
  InnerContractNo: '内部约号',
  HBLRemarks: 'HBL提单备注',
  quotationNum: '报价单号',
  Vessel: '船名',
  Voyage: '航次',
  CarrierVoyage: '船司内部航次',
  OperationDepartment: '操作部门',
  SalesDepartment: '销售部门',
  FLCLType: '整拼类型',
  ExportControlledProducts: '出口管制品',
  LocalService: '本地服务',
  NotLocalService: '无本地服务',
  SolicitationType: '揽货类型',
  SO_NO1: 'S/O No.',
  MBL_NO: 'MB/L No.',
  ServiceProduct: '服务产品',
  WoodOrNotWood: '木/非木',
  handlingInformation: 'Handling Information',
  HazardousGoodsOption: '危品选项',
  ContractRateProperty: '约价性质',
  IsNac: '是否NAC',
  ApplicableProductName: '适用品名',
  PleaseEnterNAC: '请输入NAC',
  CargoInsurance: '舱保',
  CargoInsuranceQuantity: '舱保数量',
  CargoInsuranceUnit: '舱保单位',
  ValidityStartDate: '有效期开始',
  ValidityEndDate: '有效期结束',
  ShutOut: '退关',
  ShutOutDate: '退关时间',
  CancelShutOut: '取消退关',
  ABargeOrNot: '是否有驳船',
  yes: '是',
  no: '否',
  Operation: '操作',
  Sales: '销售',
  CustomerService: '客服',
  Planner: '航线负责人',
  Documents: '单证',
  Airline: '航线',
  PreAuditPerson: '预审审核人',
  Creator: '创建人',
  Code: 'CODE',
  Accrued: '已计提',
  AirlineCode: 'LINE CODE',
  ShowRelevantBusiness: '显示关联业务',
  CustomsBroker: '报关行',
  AdvancePayment: '是否垫付关税',
  HasPrintBooking: '是否打印托书',
  PaymentTime: '缴税时间',
  CustomsDutyAmount: '关税金额',
  VatAmount: '增值税金额',
  TaxRemarks: '税款备注',
  Warehouse: '仓库',
  HaulageCompany: '运输公司',
  CarryingCmpAdjustBlockedTip: '选中订单存在未勾选门点装箱/提货，不可调整运输公司',
  AbnormalBusinessNo: '异常业务编号',
  TradeTerms2: '贸易条款',
  BusinessStatus: '业务状态',
  StatusTracking: '状态追踪',
  AuditStatus: '审核状态',
  Display: '显示',
  EstimatedArrivalTime: '预计到港时间',
  EstimatedPortArrivalTime: '预计到港/抵达时间',
  ArrivalTime: '实际到港时间',
  CustomsClearance: '目的港放关',
  ActualCustomsReleaseTime: '实际放关时间',
  DestinationPortInspection: '目的港查验',
  DestinationPortInspectionLevel: '目的港查验等级',
  DeliveryTime: '送货时间',
  ReturnTime: '还箱时间',
  DeliveryTime2: '送仓时间',
  DeliveryDate: '送货日期',
  Query: '查询',
  Return: '返回',
  Prompt1: '请输入业务编号查询',
  ResetFilter: '重置条件',
  Tip1: '双击显示SOP状态',
  TipCharge: '点击可显示业务基本信息',
  MBLIssueBillLading: 'MBL提单签发状态',
  HBLIssueBillLading: 'HBL提单签发状态',
  ConsignationRelationNumber: '委托关联号',
  BusinessCommissionedRelationNumber: '往来关联号',
  ChannelNo: '渠道单号',
  Customer: '客户',
  ConsignationStatus: '委托状态',
  ConsignationStatusTime: '委托状态时间',
  PlaceOfDelivery: '交货地',
  FinalPlaceOfDelivery: '最终交货地',
  DeliveryCountry: '交货地国家',
  AirlineArea: '航线（区域）',
  SequenceNumber: '序号',
  Tip2: '数据推送记录查询',
  View: '查看',
  Edit: '编辑',
  Cancel: '取消',
  SaveTheDefaultValues: '保存默认值',
  NominatedAgent: '指定货代理',
  NominatedAgentCount: '指定货代理数',
  ActualQuantity: '实际件数',
  ActualWeight: '实际毛重',
  ActualVolume: '实际体积',
  ChargedWeight: '计费重量',
  VolumetricWeight: '材积',
  ChargedWeightRT: '计费重量RT',
  BookingProperty: '订舱性质',
  IssueMethod: '出单方式',
  TradeMethod: '贸易方式',
  HBLFreightClause: '分单运费条款',
  HBLFreightClauseTootip: '分单运费条款',
  MBLTransportationClause: '主单运输条款',
  MBLTransportationClauseTootip: '主单运输条款',
  HBLTransportationClause: '分单运输条款',
  HBLTransportationClauseTootip: '分单运输条款',
  ContainerDescription: '箱量描述',
  FeeCreationDate: '费用创建日期',
  MBLSplitNo: '主单拆单号',
  HBLSplitNo: '分单拆单号',
  HarborDistrict: '港区',
  SOPStatus: 'SOP状态',
  HDS: 'HDS',
  TEU: 'TEU',
  AirlinePerson: '航线（负责人）',
  AirlinePerson2: '航线负责人',
  AirlineOffice: '航线公司',
  AirlineDepartment: '航线部门',
  BusinessCreator: '业务创建人',
  // 新增：币种相关列标题
  USD_Receivable: 'USD应收',
  USD_Payable: 'USD应付',
  USD_Profit: 'USD利润',
  VND_Receivable: 'VND应收',
  VND_Payable: 'VND应付',
  VND_Profit: 'VND利润',
  RMB_Receivable: 'RMB应收',
  RMB_Payable: 'RMB应付',
  RMB_Profit: 'RMB利润',
  Status: '状态',
  HblNo: 'HBL NO',
  RelevanceSoNo: '关联SO NO',
  DangerousGoodsClassification: '危险品级别分类',
  DangerousGoodsUNNo: '危险品联合国编号',
  FinalDestination: '最终目的地',
  HBLShipper: '分单发货人',
  HBLConsignee: '分单收货人',
  Add: '新增',
  mergeHblData: '合并HB/L拆单信息',
  Delete: '删除',
  AddHbl: '新增主票',
  SplitHbl: '拆分主票',
  ExportToExcel: '导出Excel',
  OverseasAgentEDI: '海外代理EDI',
  EditSopStatus: '状态修改',
  BatchPrint: '批量打印',
  BatchVessel: '批量转船',
  BatchUpdateType: '批量修改整拼类型',
  Statistics: '统计',
  BatchCommit: '批量提交',
  AddCharges: '新增费用',
  EditCharges: '编辑费用',
  DeleteCharges: '删除费用',
  print: '打印',
  PrintFclProfit: '整箱利润打印',
  PrintLclProfit: '拼箱利润打印',
  PreSubmission: '预提交',
  BatchPreSubmission: '批量预提交',
  BatchCancellation: '批量作废',
  Submission: '提交',
  SubmissionDateTime: '提交时间',
  AuditDateTime: '审核时间',
  Consignation: '委托',
  FreightStation: '货站',
  SignBill: '签单',
  ConsignationSI: '出口转进口',
  CrossTenantSeToSiEtaMustNoNull: '请补充填写字段 ：预计到港日期，该字段在进口方为必填字段！',
  ReturnAction: '退回操作',
  PrintReturn: '撤回',
  AssociationBusinessInformation: '关联业务信息',
  AssociationBusinessInformationSI: '关联进口业务信息',
  ShowAssociationBusinessInformationSI: '查看关联海运进口业务信息',
  Basic: '基本',
  Booking: '订舱',
  EnterTheCabin: '进舱',
  DataTracking: '数据追踪',
  AirDataTracking: '航运追踪',
  CustomsDeclaration: '报关',
  InsureInfo: '保险',
  Mbl: 'MBL',
  Hbl: 'HBL',
  HouseBillOfLading: 'HB/L',
  FormalHbl: '形式分单',
  Vgm: 'VGM',
  AmsEns: 'AMS/ENS',
  Hds: 'HDS',
  CommodityInspection: '商检',
  Fumigation: '熏蒸',
  ForeignTrade: '外贸',
  ConsignInfo: '委托信息',
  RequiredItem: '必录项',
  CustomerProperty: '客户属性',
  ContactPerson: '联系人',
  CustomerContactPerson: '客户联系人',
  ContactPhone: '客户联系人电话',
  ContactMobile: '客户联系人手机',
  Detail: '详细信息',
  OperationDate: '操作日期',
  ManageAuditStatus: '利润审核状态',
  PlaceOfDelivery2: '收货地',
  Transit: '中转',
  PleaseSelectShippingCompany: '请选择船公司',
  AdditionalInformation: '附加信息',
  WarehouseLoadingStorage: '内装箱/仓储',
  DoorLoadingDelivery: '门点装箱/提货',
  NotResponsibleForTruckingAndLoading: '自拉自送',
  AutoDistribution: '自动配货',
  ObtainTheWarehouseNo: '获取进仓编号',
  MblNo3: '主票号码',
  MasterBusinessNo: '主票业务编号',
  PleaseTickCustomsDeclarationOption: '请勾选【报关】选项',
  PleaseTickDoorLoadingDeliveryOption: '请勾选【门点装箱/提货】选项',
  PleaseSelectWarehouse: '请勾选【内装箱/仓储】选项',
  PleaseCheckWarehouses: '请勾选【仓储】选项',
  PlaceOfMblPayment: '主单付款地点',
  PlaceOfHblPayment: '分单付款地点',
  CargoSize: '货物尺寸',
  SpecialPriceInstructions: '特价说明',
  DirectBusiness: '直单',
  Transport: '转运',
  InBatches: '分批',
  SpecialPrice: '特价',
  ContainerInfo: '装箱信息',
  QuantityConsignActual: '件数（委/实）',
  WeightConsignActual: '毛重（委/实）',
  CubageConsignActual: '体积（委/实）',
  VolumetricWeightConsignActual: '材积（委/实）',
  ChargeWeightConsignActual: '计费重量（委/实）',
  Package: '包装',
  Pieces: '小件数',
  PiecesType: '小件数包装',
  Copy2: '抄录',
  EnglishDescriptionOfGoods: '英文品名',
  HblEnglishDescriptionOfGoods: 'HBL品名',
  Marks: '唛头',
  NCReferenceNo: '指定货参考号',
  SendProxyForecasts: '是否发送代理预报',
  SerialNumber: '序列号S/N',
  Brand: '品牌BRAND',
  ProductiveYear: '生产年份',
  CustomsValue: '报关货值',
  ChineseName: '中文品名',
  EnglishName: '英文品名',
  DeclaredValue: '申报货值',
  TariffRate: '关税税率(%)',
  EstimatedTariff: '预估关税',
  CustomsClearanceInfo: '清关信息',
  DestPortCustomsClearanceInfo: '清关信息',
  CustomsBroker: '清关行',
  Bond: 'Bond',
  UnitType: '设备型号',
  DeviceType: '设备类型CATEGORY',
  CountryOrigin1: '原产国',
  DeviceStatus: '设备状态（新旧）',
  HsCode: 'HS编号',
  bookingNotes: '订舱备注',
  DangerousGoodsRemarks: '危险品备注',
  BootHelperPage: '引导辅助页',
  ChineseDescriptionOfGoods: '中文品名',
  OperationInfo: '操作信息',
  SalesCompany: '销售公司',
  OperationCompany: '操作公司',
  OperationRequirements: '操作要求',
  DoubleClickToAddOperationRequirements: '双击添加操作要求',
  OperationTips: '操作提示',
  ExtraChargeClause: '附加费条款',
  DoubleClickToAddExtraChargeClause: '双击添加附加费条款',
  WarehousingInfo: '入库信息',
  Remarks: '备注',
  BasicRemarks: '备注（基本）',
  manifestInformation: '舱单基本信息',
  manifestChannel: '预配舱单通道',
  CustomerDeliveryInfo: '客户发运信息',
  CodeSearching: '代码检索',
  CopyToSeller: '复制到卖方',
  CopyToBuyer: '复制到买方',
  ExpandSellerBuyer: '展开卖方/买方',
  NoHouseNumber: '没有门牌号',
  NotifyParty: '通知人',
  NotifyPartyCode: '通知人code',
  MblShipperLine1: 'MBL 发货人',
  MblConsigneeLine1: 'MBL 收货人',
  MblNotifyLine1: 'MBL 通知人',
  DocDispatchingPlace: '提单发货地',
  SecondNotifyParty: '第二通知人',
  PleaseSelect: '请选择',
  Add2: '新增',
  WhetherDeclarations: '是否报关',
  InBatchesOrNot: '是否分批',
  BookingInfo: '订舱信息',
  MultiJourneyAirline: '多程航司',
  NumberPasses: '程数',
  MergingTickets: '合并小票',
  TicketsInfo: '小票信息',
  TotalTickets: '总票数',
  NewTickets: '新增小票',
  EditTickets: '编辑小票',
  AddTickets: '加入小票',
  RemoveTickets: '移除小票',
  DeleteTickets: '删除小票',
  Etd: 'ETD',
  SoNo: '加拼单号',
  FunctionalOperation: '功能操作',
  MblNo2: 'MB/L NO',
  BookingShipCallSign: '船舶呼号',
  USAirlineInfo: '美线信息',
  PortInfo: '港区信息',
  PolPortInfo: '起运港港区信息',
  PolAirPortInfo: '起运港机场信息',
  PodPortInfo: '目的港港区信息',
  PodAirPortInfo: '目的港机场信息',
  LocalTime: '（数据返回的是当地时间）',
  TopLocalTime: '温馨提示：时间显示的是当地时间',
  CYOpeningDate: '开港日期',
  PolPortInfoPrompt: '橙色字段在开通数据服务后可支持数据回写',
  CYOpeningTime: '开港时间',
  CYCutOffDate: '截港日期',
  PortAreaCYCutOffTime: '港区截港时间',
  PortAreaCYOpeningTime: '港区开港时间',
  CarrierCyCutOffTime: '船公司截港时间',
  PlannedDateOfBerthing: '计划靠泊日期',
  PlannedDateOfLeavingBerth: '计划离泊日期',
  ActualDateOfBerthing: '实际靠泊日期',
  ActualDateOfLeavingBerth: '实际离泊日期',
  PlannedDockingBerths: '计划靠泊泊位',
  TheActualDockingBerths: '实际靠泊泊位',
  ActualTimeOfArrivalThePort: '实际进港日期',
  EquipmentEstimatedReturnTime: '预计还柜期间',
  EquipmentEstimatedReturnTimeTootip: '预计还柜期间',
  To: '至',
  OtherInfo: '其他信息',
  CyCode: '堆场代码',
  PortCodeOfDischarge: '卸货港代码',
  EquipmentReceiptAddress: '交单地址',
  EquipmentReceiptContactPerson: '交单联系人',
  EquipmentReceiptContactWay: '交单联系方式',
  CustomerCyCutOffDate: '客户截关日期',
  CustomerShutOutDate: '客户退关日期',
  AmsEnsCyCutOffDate: 'AMS/ENS截关日期',
  FreeDetension: '免柜租期',
  SecondVesselInfo: '海运二程信息',
  AirSecondVesselInfo: '空运二程信息',
  SecondVoyage: '二程航次',
  BargeInfo: '支线驳船信息',
  ServiceCode: '船舶航线代码',
  ModulesInfo: '配舱信息',
  ShippingAdviceRemark: 'SHIPPINGADVICE备注',
  BookingConfirmationRemarks: '配舱通知书备注',
  InviteToChecktheBL: '邀请对单',
  ConfirmChecking: '确认对单',
  IdentificationList: '识别对单',
  ChecktheBLBySmart: '智能对单',
  ViewCheckingFile: '查看对单文件',
  CheckingHistory: '对单历史',
  UploadGuarantee: '上传保函',
  ReceiptHistory: '回执历史',
  CopyTheDataBy: '数据抄录',
  CopyFromTheLastTime: '抄录上次',
  CopyFromOtherBill: '单号抄录',
  CopyFromHbl: '抄录HBL',
  CompleteTheDetails: '完成补料',
  Printed: '已打印',
  Locked: '已锁定',
  ShipperLocked: '已锁定发货人',
  BlBeReleased: '异地放单',
  BlEdi: '提单EDI',
  ManifestEdi: '舱单EDI',
  ShowNumberOfPackagesGrossWeightAndMeasurementAfterCNTRNOSSEALNOS: '箱封号后跟件数毛重体积',
  PrintBargeVesselAndVoyage: '打印驳船船名航次',
  ConsigneeShipperAndNotifyInfo: '收发通信息',
  Reset: '清除',
  CopyTheConsignee: '抄录收货人',
  CargoInfo: '货物信息',
  OnlyOriginalSend: '只能发原始',
  OnlyAddAndDeleteSend: '只能发修改和删除',
  NoSuccessAddAndDeleteNotSend: '未发送成功，无法再次发送修改或者删除',
  NeedFillPortBeforeEnteringEU: '需填写进入欧盟前的港口',
  SyncContainerInfoTotal: '取装箱信息件毛体',
  SyncContainerInfoContent: '装箱信息件毛体覆盖MBL,是否覆盖？',
  SyncContainerInfoQuantity: '件数（装箱）: {0} -----> 件数（MBL）: {1}',
  SyncContainerInfoWeight: '毛重（装箱）: {0} -----> 毛重（MBL）: {1}',
  SyncContainerInfoCubage: '体积（装箱）: {0} -----> 体积（MBL）: {1}',
  NumberOfPackagesOnBl: '提单件数',
  Pieces2: '小件件数',
  PiecesType2: '小件包装',
  Weight: '毛重',
  WeightUnit: '毛重单位',
  Cubage: '体积',
  CubageUnit: '体积单位',
  CopyEnglishDescriptionOfGoodsFromReceipt: '取小票英文品名',
  CopyEnglishDescriptionOfGoodsFromHBL: '取HBL英文品名',
  CopyMarksFromHbl: '取HBL唛头',
  CapitalizedNumbersOfPackages: '件数大写',
  TransportInfo: '运输信息',
  VesselAndVoyage: '船名航次',
  PlaceOfReceipt: '发货地',
  PlaceOfReceiptOnBl: '提单发货地',
  PlaceOfReceiptCodeOnBl: '发货地(代码)',
  PlaceHolderPOR: '请选择提单发货地代码',
  PlaceOfReceiptOnBlTootip: '提单发货地',
  PortOfLoadingOnBl: '提单起运港',
  PortOfDischargeOnBl: '提单卸货港',
  PlaceOfDeliveryOnBl: '提单交货地',
  BlFinalDestination: '提单最终目的地',
  MethodOfMblPayment: 'MBL付款方式',
  PlaceOfMblPayment2: 'MBL付款地点',
  TransportationClause: '运输条款',
  NoOfOriginalBls: '提单份数',
  NoOfCopyBls: '副本份数',
  PlaceOfIssue: '签发地点',
  DateOfIssue: '签发日期',
  HBLDateOfIssue: 'HBL签发日期',
  BlRemarks: '提单备注',
  BlType: '提单方式',
  HBLBlType: 'HBL提单方式',
  MBLBlType: 'MBL提单方式',
  MBLBlProperty: 'MBL提单种类',
  HBLBlProperty: 'HBL提单种类',
  LastEntryPort: '最后入境港口',
  BlProperty: '提单种类',
  CheckingStatus: '提单确认状态',
  BillLadingIssued: '提单签发状态',
  HBLCheckingStatus: 'HBL提单状态',
  MBLCheckingStatus: 'MBL提单状态',
  ReleasingStatus: '放单审核状态',
  HBLReleasingStatus: 'HBL放单状态',
  MBLReleasingStatus: 'MBL放单状态',
  ReleaseEligibleStatus: '放单状态',
  ReleaseEligibleYes: '可放单',
  ReleaseEligibleNo: '不可放单',
  FormalHblReleaseType: '形式分单方式',
  FormalHblStatus: '形式分单状态',
  FormalHblIssuedStatus: '形式分单签发状态',
  FormalHblType: '形式分单类型',
  FormalHblCombineNo: '形式分单并单号',
  fields: '字段与',
  tab: '页签',
  hint: '字段不一致，是否确认发送？',
  Audit: '审核',
  Payable: '可付款',
  CargoDetention: '扣货',
  PaymentDate: '付汇日期',
  PaymentDate2: '付汇日期',
  DateOfCargoDetention: '扣单日期',
  BlReleasingNo: '放单号',
  BlReleasingApplicationTime: '放单申请时间',
  BlReleasingApplicationPerson: '放单申请人',
  ParamRemark: '签章备注',
  ShippingCompanySCAC: '船公司SCAC',
  OverseasAgentSCAC: '海外代理SCAC',
  ShipperType: '发货类型',
  ManifestDescriptionOfGoods: '舱单品名',
  ReasonOfCargoDetention: '扣单原因',
  HblNo2: 'HBL编号',
  MblNo: 'MBL编号',
  Quantity: '件数',
  WeightKg: '毛重(KG)',
  CubageCbm: '体积(CBM)',
  ContainerAmount: '箱量',
  CNTRNOSSEALNOS: '箱封信息',
  BillOfLadingPackingInfo: '提单装箱信息',
  CopyMblConsignee: '取主单收货人',
  CopyNominatedAgentInfo: '取指定货代理信息',
  PrintTheOriginalBl: '正本打印',
  TelexRelease: '电放打印',
  Unlock: '解锁',
  AntiTerroristFormattedAddress: '反恐地址格式化',
  BlBeReleasedElsewhereOrNot: '是否异地放单',
  ClauseOfNoWoodPackingMaterial: '非木制包装条款',
  AFRTheLastBill: 'AFR最后一票',
  CopyEnglishDescriptionOfGoodsFromMbl: '取MBL英文品名',
  CopyMarksFromMbl: '取MBL唛头',
  BillOfLadingNumber: '提单流水号',
  HBLBillOfLadingNumber: 'HBL 提单流水号',
  MethodOfHblPayment: 'HBL付款方式',
  PlaceOfHblPayment2: 'HBL付款地点',
  CheckingQuestions: '对单疑问',
  BlType2: '提单类型',
  HBLBlType2: 'HBL 提单类型',
  DataSent: '已发资料',
  Completed: '完成',
  paste: '粘贴附件',
  V3remind: '请先复制附件',
  DateOfcompletion: '完成日期',
  GenerationOfABillOfLading: '代出提单',
  GenerationOfABillOfLading2: '代出提单',
  ShipperContactTelNo: '发货人联系电话',
  ConsigneeContactTelNo: '收货人联系电话',
  NotifyPartyTelNo: '通知人联系电话',
  ChargeClause: '付费条款',
  Amount: '金额',
  CopyCargoDescriptionAndMarks: '唛头品名抄录',
  CopyMbl: '抄录MBL',
  RelatedMbl: '关联主单',
  Add3: '加入',
  Copy: '拷贝',
  Send: '发送',
  CheckStatus: '查询状态',
  ImportButNotSend: '导入不发送',
  CapitalizedNumbersOfEquipmentWeight: '箱重大写',
  AmsSplitNo: 'AMS分单号',
  AmsNo: 'AMS编号',
  EManifestSplitNo: 'eManifest分单号',
  EManifestNo: 'eManifest编号',
  BlSplitList: '分单列表',
  sendStatusAMS: '发送状态(AMS)',
  sendStatusISF: '发送状态(ISF)',
  sendStatus: '发送状态',
  SealNoChangeAdfterInspection: '查验更改封号',
  AutoAllocation: '自动装箱',
  AutoAllocationContract: '自动装箱(委托)',
  CleanOutTheLoadingRecord: '清空装箱记录',
  DeleteTheLoadingRecord: '删除装箱记录',
  CargoQuantityDescription: '货量描述',
  TotalNumberOfPackages: '总件数',
  ContainerSize: '箱型',
  ContainerType: '箱种',
  ContainerWeight: '箱重',
  SealNo: '封号',
  TravelTrajectory: '行程轨迹',
  DrivingState: '当前行驶状态',
  CurrentVehicleLocation: '当前车辆位置',
  GetContainerNo: '获取箱号',
  TotalWeight: '总毛重',
  TotalCubage: '总体积',
  Soc: '货主箱',
  Inspection: '查验',
  ApproachDate: '进场时间',
  PlayDate: '出场时间',
  LoadingPort: '装货港',
  TheArrivalOfPacketsSent: '运抵报文发送时间',
  CustomsClearanceInfo: '海关放行信息',
  DataTrackingBlHasNotContainer: '提单号{0}，请前往装箱信息页签使用数据对比功能后则会关联。本页签将会显示箱子详细信息。 ',
  WharfReleaseInfo: '码头放行信息',
  ContainerAscription: '箱属',
  PlateNumber: '车头号',
  plateApproachDate: '集卡进场时间',
  platePlayDate: '集卡出场时间',
  PackageType: '包装类型',
  NumberOfVotes: '票数',
  EmptyContainerWeight: '空箱重量',
  VgmWeight: 'VGM重量',
  VgmWeighingMethod: 'VGM称重方法',
  VgmWeighingTime: 'VGM称重时间',
  WeightTime: '称重时间',
  VgmWeighingPlace: 'VGM称重地点',
  WeighingPartyAddress: '称重方地址',
  StationStatus: '场站状态',
  CargosGrossWeight: '货物毛重',
  VgmContactPerson: 'VGM联系人',
  VgmContactEmailAddress: 'VGM联系邮箱',
  VgmContactWay: 'VGM联系方式',
  VgmResponsiblePerson: 'VGM负责人',
  ContactEmailAddress: '联系邮箱',
  ContactWay: '联系方式',
  ContactAddress: '联系地址',
  ResponsiblePerson: '负责人',
  Name: '名称',
  Warehouse2: '内装仓库',
  WarehouseLoading: '仓库内装',
  LoadingCharge: '装箱费',
  LoadingCharge2: '装箱费',
  BoxOwner: '箱主',
  RmbNumberOfDamagedAndDamp: '破损受潮件数',
  RmbNumberOfDamagedAndDamp2: '破损受潮件数',
  Tel: '电话',
  CargosExpectedArrivalDate: '预计到货日期',
  WarehouseAddress: '仓库地址',
  LoadingRemarks: '内装备注',
  DoorToDoorLoading: '门到门装箱',
  MultiDoors: '多门点',
  HaulageNo: '派车单号',
  HaulageCharge: '拖车费',
  AuditMoney: '确认金额',
  AuditState: '费用状态',
  HaulageContactPerson: '车队联系',
  Door: '门点',
  AddDoor: '新增门点',
  DestinationGatewayCity: '目的门点城市',
  DoorContactPerson: '门点联系人',
  DoorAddress: '门点地址',
  DispatchVehiclesAtDestinationDoorAddress: '目的港派车门点地址',
  DoorCity: '门点城市',
  Driver: '司机',
  ComprehensiveLogisticsOrderType: '综合物流订单类型',
  ComprehensiveLogisticsTransportationType: '综合物流运输类型',
  TransportType: '运输类型',
  SameTransportationCompany: '运输公司相同',
  SameDoorPoint: '门点相同',
  ReturnYard: '还箱堆场',
  DriverIDCard: '司机身份证',
  DestinationGatePoint: '目的地门点',
  DepartureGatePoint: '起运地门点',
  AddressOfDestinationGatePoint: '目的地门点地址',
  DestinationGateCity: '目的地门点城市',
  CarryingCaseYard: '提箱堆场',
  EstimatedPackingDate: '预计装箱（到厂）日期',
  ActualPackingDate: '实际装箱（到厂）日期',
  EstPackingDate: '预计装箱（到仓）日期',
  ActPackingDate: '实际装箱（到仓）日期',
  ExpectedArrivalDate2: '预计到货日期',
  ActualArrivalDate: '实际到货日期',
  GatheringTrailer: '集卡拖车',
  WholeVehicleLessThanCarload: '整车零担',
  TruckCustomerService: '卡车客服',
  DtdDTWWTD: '门到门/门到仓/仓到门',
  DoorToDoor: '门到门',
  DoorToWarehouse: '门到仓',
  WarehouseToDoor: '仓到门',
  AdditionalNotes: '附加说明',
  DestinationPortAdditionalFee: '目的港附加费',
  AssociatedPackingInfo: '关联装箱信息',
  RemoveAssociations: '移除关联',
  DispatchTuckOrder: '派单',
  ModifyTuckOrder: '改单',
  TuckStatusDescription: '派车详情',
  ManualDistribution: '手动配货',
  Unlock2: '解除',
  Size: '尺寸',
  WhetherOrNotBroken: '是否破损',
  BrokenDesc: '货损描述',
  BangPic: '进仓照片',
  WareHouseName: '仓库名称',
  WarehouseSupplier: '仓库供应商',
  WareHouseMarks: '仓库唛头',
  CustomsDeclarationInfo: '报关信息',
  OnwardInfo: '续程信息',
  TheActualFlight: '实际航班',
  NewCustomsDeclaration: '新增报关单',
  EditCustomsDeclaration: '编辑报关单',
  DeleteCustomsDeclaration: '删除报关单',
  BlNo: '提单号',
  OperatingCompany: '经营单位',
  CustomsCode: '报关十位码',
  DateOfCustomsDeclaration: '报关日期',
  StatusOfCustomsDeclaration: '报关状态',
  CommodityInspectionOrNot: '是否商检',
  CustomsInspectionOrNot: '是否查验',
  UploadFile: '上传文件',
  CustomsFile: '报关文件',
  Chargeback: '退单',
  TemplateDownload: '下载模板',
  ExcelImport: 'Excel导入',
  ExcelExport: 'Excel导出',
  OrderNo: 'ORDER NO_订单号',
  CaseNo: 'CASE NO_序号',
  Item: 'ITEM_商品编码',
  Sub: 'SUB_批号',
  Size2: '规格',
  CommodityClassification: '归类品名',
  Qty: 'QTY_件数',
  BillingQTY: '计费数',
  UnitOfMeasurement: '计量单位',
  NetWeight: '净重',
  CustomsDutyRate: '关税税率',
  CustomsDuties: '关税',
  IncrementValueDutyRate: '增值税税率',
  IncrementValueDuty: '增值税',
  ConsumptionDutyRate: '消费税税率',
  ConsumptionDuty: '消费税',
  ConsolidatedTax: '综合税',
  Currency: '币种',
  ExchangeRate: '汇率',
  CargoPrice: '货价',
  Tax: '税金',
  TaxRate: '税率',
  BigBagNo: '大包号',
  BigBagWeight: '大包重量',
  BigBagWeightUnit: '重量单位',
  BigBagLength: '大包裹长',
  BigBagWidth: '大包裹宽',
  BigBagHeight: '大包裹高',
  BigBagDimensionUnit: '大包长度单位',
  BigBagGoodsType: '大包货物类型',
  FulfillmentLabel: '履约类型',
  LandingPort: '落地口岸',
  PackageQuantity: '小包装数量',
  ExpectPickupStartTime: '期望揽收开始时间',
  ExpectPickupEndTime: '期望揽收结束时间',
  PreviousCarrierCode: '上一个服务商code',
  PreviousResourceCode: '上一个资源code',
  NextCarrierCode: '下一个服务商code',
  NextResourceCode: '下一个资源code',
  SortCode: '大包分拣码',
  BuyerRegion: '目的国',
  AddressL0: 'L0级地址',
  AddressL1: 'L1级地址',
  AddressL2: 'L2级地址',
  AddressL3: 'L3级地址',
  AddressL4: 'L4级地址',
  DetailsAddressMore: '详细地址2',
  PickupFirstName: '揽收人姓',
  PickupLastName: '揽收人名称',
  PickupCompany: '揽收地公司名称',
  PickupZip: '揽收地邮编',
  PickupPhone: '揽收地手机号',
  TtOrderCode: 'tt板号',
  MwbNo: '服务商提单号',
  Export9610File: '导出9610文件',
  BatchChangeCompany: '批量更换公司',
  OnlyCheckOneData: '只允许勾选一条数据',
  NoteUseNumLast: '注意:更换公司后单号不会重新生成，依然会使用现有单号。',
  OrderNo2: '订单号',
  SupportSales: '销售支持',
  OrderAmount: '订单金额',
  ServiceFeeDiscountRate: '服务费折扣率',
  OperatingInstructions: '操作说明',
  OrderCurrency: '订单币种',
  TheAmountOfWriteOffs: '订单核销金额',
  TheFirstBusinessOrNot: '是否首单',
  Salesman: '业务员',
  OrderExchangeRate: '订单汇率',
  Difference: '差额',
  FrameContractNumber: '框架合同号',
  PaymentNo: '付汇编号',
  PaymentAmount: '付汇金额',
  ThePrePayment: '付汇预款项',
  PaymentExchangeRate: '付汇汇率',
  ActualPaymentAmount: '实际付汇金额',
  ServiceCharge: '手续费',
  PostalCharges: '邮电费',
  AcceptanceFee: '承兑手续费',
  RetreatMoreFillLessAmount: '多退少补金额',
  Total: '汇总',
  UnpaidAmount: '未付汇金额',
  No: '否',
  Yes: '是',
  New: '新建',
  Clone: '复制',
  Send2: '送出',
  Back: '取回',
  ExpressInfo: '快递',
  PrintReceipt: '打印回执单',
  FileType: '文件类型',
  FileType2: '类型',
  FileCategory: '文件类别',
  CustomsNo: '海关编号',
  SendingDate: '送出日期',
  SendingExpressNumber: '送出快递号',
  ReceivingDate: '取回日期',
  Receiver: '取回人',
  ReturnDate: '退还日期',
  ReturnExpressNumber: '退还快递号',
  DateOfDeclaration: '申报日期',
  FileStatus: '文件状态',
  TenBitCode: '十位码',
  ReceiverCompanyName: '收件单位',
  Receiver2: '收件人',
  CustomsDeclarationPages: '报关页数',
  CustomsTransitOrNot: '是否转关',
  TakeByCustomsBroker: '报关行自取',
  ExpressAddress: '快递地址',
  PrintChargebackList: '打印（退单清单）',
  ViewFile: '查看文件',
  ChargebackFile: '退单文件',
  CheckPreRecordedCustomsDeclaration: '报关单预录查询',
  CheckStatusOfCustomsDeclaration: '报关状态查询',
  All: '全部',
  GeneralTrade: '一般贸易',
  Processing: '来料加工',
  FeedingCounterparts: '进料对口',
  SamplesOfAdvertisingProducts: '货样广告品',
  OtherImportsFree: '其他进口免费',
  CustomerName: '客户名称',
  CustomerAddress: '客户地址',
  Confirm: '确认',
  DangerousGoods: '危险品',
  DangerousGoodsRequired: '“危险品联系人邮箱”、“危险品联系人传真”必填',
  DangerousGoodsLabel: '危险品标签',
  MedicalEmergencyGuideNo: '医疗救急指南号',
  SetTemperature: '设置温度',
  MinimumTemperature: '最低温度',
  MaximumTemperature: '最高温度',
  PortForReturningContainer: '送箱港区',
  NonStandardContainer: '加非标准箱',
  OverFront: '前超',
  OverBack: '后超',
  OverHeight: '超高',
  OverLeft: '左超',
  OverRight: '右超',
  EditionStatus: '编辑状态',
  UpdateExternalState: '更新外部状态',
  Refresh: '刷新',
  Save: '保存',
  ShowAllPoints: '显示全部节点',
  SopStateNote: '*注意：已关闭的节点将不再发送节点预警和SOP状态变更通知',
  PaymentInformationImport: '支付信息导入',
  Invalid: '作废',
  InvalidDate: '作废时间',
  QueryContainerInfo: '装箱信息查询',
  Hbl2: '分单号',
  Mbl2: '主单号',
  PortOfLoadingAgent: '起运港代理',
  TheFirstVessel: '一程船名',
  CustomerReferenceNumber: '客户参考号',
  BusinessType: '业务类型',
  BillExchange: '是否换单',
  Storage: '仓储',
  Devanning: '拆箱',
  DeliveryToDoor: '门点送货',
  MblNo4: '主票编号',
  InternationalTransport: '国际运输',
  ActualNotifyParty: '实际通知人',
  ActualNotifyPartyHeader: '实际通知人抬头',
  ConsignationCompanyHeader: '委托单位抬头',
  Fax: '传真',
  BillExchangeAgent: '换单代理',
  CustomsHblNo: '海关分单号',
  SecondCheck: '二程',
  SecondVessel: '二程船名',
  AutoRetrieve: '自动获取',
  AccordingToVesselVoyageGets: '根据船名航次获取',
  ActualDateOfArrival: '实际到港日期',
  ActualDateOfArrival2: '实际到港日期(ATA)',
  AtaImport: 'ATA(进口)',
  DateOfDelivery: '提货日期',
  DateOfArrivalTheWarehouse: '到库日期',
  Code2: '代码',
  Region: '区号',
  CountryOrigin: '原产地',
  PartyIDType: '证件类型',
  PartyID: '证件号码',
  BillsOfLadingDoubleClickEject: '提单抬头-双击弹出',
  TradeTerms: '成交条款',
  PreCollection: '预收款',
  HblCargoReleaseWay: '分单放货方式',
  MblCargoReleaseWay: '主单放货方式',
  VesselCode: '船舶代码',
  BillExchangeDate: '换单日期',
  Department: '部门',
  PolOperation: '起运港操作',
  PodOperation: '目的港操作',
  VesselOfChineseName: '中文船名',
  TotalWeight2: '总重量',
  TotalWeightUnit: '总重量单位',
  NumberOfDamagedAndDamp: '破损受潮件数',
  EstimatedDateOfArrivalTheWarehouse: '预计入库日期',
  EstimatedDateOfPickingUpTheContainer: '预计提箱日期',
  DateOfReturningTheContainer: '还箱日期',
  SanitaryAndPhytosanitaryStandard: '动卫检',
  PriceCalculation: '卖价计算',
  Down: '下移',
  Up: '上移',
  Total2: '合计',
  PrintBooking: '订舱打印',
  FirstLegNo: '头程编号',
  FirstLegNoTips: '用于国际空运物流中用于管理国内段运输及出口前操作的关键标识符',
  OperateType: '操作模式',
  CustomsDeclarationWay: '报关方式',
  CustomsDeclarationType: '报关类型',
  AirlineCompany: '航空公司',
  Flight: '航班',
  FlightNo: '航班号',
  PortOfHub: 'HUB港',
  CommissionedNumberOfPackages: '委托件数',
  CommissionedGrossWeight: '委托毛重',
  CommissionedVolume: '委托体积',
  ActualChargedWeight: '实际计费重量',
  PrintingPlatePhotos: '打板照片',
  ProtocolType: '协议类型',
  FieldOperation: '现场操作',
  OverseaOperation: '海外操作',
  Auditor: '审核人',
  preverifyDate: '审核日期',
  OtherWarehouseNotes: '其它说明',
  JobNo: '工作号',
  NominatedAgent2: '指定代理',
  AirFreighMode: '空运模式',
  WarehouseNo2: '进舱编号',
  PleaseInputJobNo: '请输入工作号',
  PrintProfitAnalysis: '利润分析打印',
  SendToBranchCompany: '发送分公司',
  EnterTransitInfo: '输入中转信息',
  ArrivalForTheSecondJourney: '抵达二程',
  LeaveForTheSecondJourney: '离开二程',
  ArrivalForTheThirdJourney: '抵达三程',
  LeaveForTheThirdJourney: '离开三程',
  PreAlertOperation: '预报操作',
  Actual: '实际',
  Frontcabin: '前置仓',
  FrontCabinActual: '前置仓（实际）',
  Documentation: '制单',
  Select: '选择',
  Join: '加入',
  Separate: '分离',
  pbProportion: '客户分泡',
  pbProportion2: '供应商分泡',
  SpaceRquirement: '舱位要求',
  OnBoardRequirements: '装板要求',
  DocumentationRequirements: '制单要求',
  SellingPrice: '卖价',
  BuyingPrice: '买价',
  SalesBranchCompany: '销售分公司',
  CopyFromOtherBill2: '号码抄录',
  CodeSearching2: '代码选择',
  ResetInitialValue: '重置初始值',
  CopyTheMbl: '抄录主单',
  InputWarehouseData: '录入进仓数据',
  EditWarehouseData: '编辑进仓数据',
  DeleteWarehouseData: '删除进仓数据',
  CancelInvalid: '取消作废',
  MblInfo: '主票信息',
  AirOperation: '空运操作',
  CustomerSpecialRequirements: '客户特殊需求',
  AirportHandlingAgent: '地面代理',
  CustomsTenBitCode: '报关十位编码',
  InspectionTenBitCode: '报检十位编码',
  TradeDetail: '货物明细',
  TradeCommission: '贸易',
  HblInfo: '分单信息',
  MBLInfo: '主单信息',
  Charge: '费用',
  InternalBillInfo: '国内账单',
  OverseaBillInfo: '国外账单',
  AdvanceChargeInfo: '代收垫付',
  DocumentCirculation: '单证流转',
  FileHistory: '文件历史',
  ImportToPDF: 'PDF导入',
  Trucking: '客户门点',
  ImportOperation: '进口操作',
  CustomsDeclarationOnward: '报关/续程',
  WarehouseDoorLoading: '仓库内装/门点装箱',
  GrossWeight: '毛重',
  CustomJobType: '自定义业务类型',
  TaxNature: '税务性质',
  ContainerInfo2: '箱货信息',
  ContainerIdentification: '箱货标识',
  CopyConsignationDescriptionAndMarks: '从委托唛头品名抄',
  SelecteAll: '选择所有',
  ConsigneeShipperAndNotifyAddress: '收发通地址',
  ShipperId: '发货人代码',
  ConsigneeId: '收货人代码',
  NotifyId: '通知人代码',
  ShipperInfo: '发货人信息',
  ConsigneeInfo: '收货人信息',
  NotifyInfo: '通知人信息',
  CopyShipper: '选择发货人',
  CopyConsignee: '选择收货人',
  CopyNotify: '选择通知人',
  CopyManifestShipper: '选择舱单发货人',
  CopyManifestConsignee: '选择舱单收货人',
  CopyManifestNotify: '选择舱单通知人',
  CopyAll: '选择',
  FillInQuantityOfVotes: '票数填写',
  QueryLCLJobOrder: '加入拼箱工作单查询',
  QueryLCLJobOrder2: '加入分单工作单查询',
  QuantityOfSelectedOrder: '选中票数',
  NoDisplay: '不显示',
  Number: '票数',
  SelectSoNo: 'S/O No选择',
  MBLHBR: 'MBL并单号',
  AgentInfo: '代理信息',
  HBLHBR: 'HBL并单号',
  ChargeItem: '费用名称',
  Close: '关闭',
  SearchJobNo: '工作单检索',
  SerialNo: '流水号',
  Search: '检索',
  VolumeOnBl: '提单体积',
  MethodOfPayment: '付款方式',
  PortOfFinalDestination: '最终目的港',
  SelectContainerInfo: '选择装箱信息',
  SearchTheWarehouseRecords: '查询仓库记录',
  ReceiptNo: '回执单号',
  warehouseOp: '仓库员',
  deliveryCMP: '送货公司',
  inDate: '入库日期',
  DamagedAndDamp: '破损受潮',
  EntryCustomsInformation: '报关信息录入',
  Recorded: '已录入',
  ListPulled: '已拉单',
  AtReception: '在前台',
  CustomsDeclared: '报好',
  Undeclared: '未报好',
  CustomsExamination: '海关查验',
  InspectionExamination: '商检查验',
  ExamedWithoutReleasing: '已查未放行',
  AmendDeclaration: '改单',
  NotifyToDeclare: '等通知报关',
  CustomsExamed: '海关查验有问题',
  PreNumber: '录入编号',
  ContainerNo2: '柜型柜号',
  UnknownState: '未知状态',
  ProductName: '方案名称',
  Carrier: '承运人',
  RecordCount: '记录数',
  Autowire: '自动匹配',
  SchemaName: '方案/费用名称',
  Receivable: '收付',
  PartnerType: '结算单位类型',
  Account: '固定结算单位',
  MeasureCurrency: '计费单位',
  MeasureUnit: '计费单元',
  UnitRate: '单价',
  MiniMum: '最低收费',
  FCLFreightTariff: '整箱运价表',
  PleaseInputTariffSheet: '请输入运价单号.',
  CostLeave: '运价等级:',
  ValidFrom: '有效期自',
  ValidTo: '有效期至',
  MON: '周一',
  TUE: '周二',
  WED: '周三',
  THU: '周四',
  FRI: '周五',
  SAT: '周六',
  SUN: '周天',
  GetCostsByTheCabinet: '按柜型分列费用',
  ShippingFeesAreALLINTHEWAYImport: '海运费是否ALL IN方式导入',
  PriceNo: '运价号',
  BranchCMP: '分公司',
  IsDirect: '直达',
  PriceState: '舱位状态',
  Trend: '趋势',
  Share: '舱位性质',
  ContractNo: '约号',
  PriceFrom: '运价来源',
  SailingDate: '船期',
  Voyage2: '航程',
  Cargo: '货物',
  Box: '箱',
  Dock: '挂靠码头',
  LCLFreightTariff: '整箱运价表',
  ImportCostsByPeers: '按同行价导入费用',
  PriceState2: '运价状态',
  CostValue: '成本价',
  PeerPrice: '同行价',
  DirectPrice: '直客价',
  MarketPrice: '市场价',
  ClosingDay: '截关日',
  ShareCarrier: '共舱船公司',
  VerificationSchedule: '核销明细表',
  Cash: '现金',
  Check: '支票',
  Transfer: '转账',
  ClearingDate: '核销日期',
  PayReceiveDate: '收付日期',
  VerificationBy: '核销人',
  ClearCurrency: '核销币种',
  ClearRate: '核销汇率',
  ClearAmount: '核销金额',
  VoucherNo: '凭证号',
  OurBank: '我方银行',
  AddBillCharge: '加入费用',
  RemoveBillCharge: '移除费用',
  ShowBillDetail: '显示账单信息',
  Close2: '收起',
  OverseasBillingMaintenance: '海外账单维护',
  MainOffice: '账单抬头公司',
  BillType: '账单类型',
  BillAmount: '税额',
  AccountObject: '结算对象',
  Bank: '开户银行',
  BankAccount: '银行账号',
  CounterPartyBillingNo: '对方账单号',
  InputDate: '账单日期',
  RevenueTotalGroup: '分币种合计',
  IncludingTaxAmount: '含税价',
  ExcludingTaxAmount: '不含税价',
  WhetherCollectingAdvance: '是否代收垫付',
  Unit: '单位',
  Quantity2: '数量',
  ShowLcl: '显示小票费用',
  AgentIntoBills: '代理分成账单',
  Office: '账单抬头分公司',
  Percentage: '分成比例',
  IsPercentage: '分成',
  ChargeEnglishName: '费用英文名',
  ChangeSchema: '费用方案',
  SendEMail: '发送邮件',
  LocalAgent: '本地代理',
  placeholderVal: '请先勾选邮件模板后选择模板',
  UpDestAgent: '起/目的港代理',
  Haulage: '车队',
  CompanyName: '公司名称',
  GroupCode: '公司代码',
  CompanyAddress: '公司地址',
  Contact: '联系人',
  OtherInformation: '其他信息',
  BlTitle: '提单公司名',
  BlAddress: '提单地址',
  BlContact: '提单联系信息',
  MscBlAddress: 'Msc提单地址',
  PleaseChooseItem: '请先选择需要操作的项目.',
  WhetherDelete: '确认是否删除?',
  IsEmptyPleaseEnter: '为空,请填写完整.',
  Cc: '抄送',
  MailContent: '邮件内容',
  SystemEmail: '系统邮箱',
  CompanyMail: '公司邮箱',
  PersonalMailbox: '个人邮箱',
  emailSubject: '邮件主题',
  mailTemplate: '邮件模板',
  SaveTheDefaultCC: '保存默认抄送人',
  Title: '主题',
  Content: '内容',
  operationalMotion: '操作动作',
  operationTime: '操作时间',
  customsReceiptStatus: '海关回执状态',
  returnTime: '返回时间',
  source: '来源',
  FileUpload: '文件上传',
  FileName: '文件名',
  FileSize: '文件大小',
  UploadProgress: '上传进度',
  DocumentType: '文档类别',
  SelectFile: '选择文件',
  DeleteFile: '删除文件',
  Upload: '上传',
  PlsSeeEIR: '请见设备交接单',
  SelectCopyContent: '选择复制内容',
  DuplicateContent: '复制内容',
  BasicInfo: '基本信息',
  ByThisTimeAfterSelectingTheCopiedWithoutHavingToAsk: '以后按本次选择复制，无需再问。如需要重新设定条件，可以在右上角的设置与工具——页面个性化中点击设置按钮',
  ByThisTimeAfterSelectingTheCopiedWithoutHavingToAskLeft: '将本次所选内容设置为默认复制内容，下次不再提醒',
  ByThisTimeAfterSelectingTheCopiedWithoutHavingToAskRight: '如需重新设置复制内容，请到右上角菜单图标-设置与工具-页面个性化中，点击设置按钮',
  Slaves: '小票票数',
  Master: '主票票数',
  CustomerCount: '客户数',
  SingleWeight: '单件重量',
  Weight2: '重量',
  ReceivableType: '收支类型',
  AccountType: '结算单位类型',
  Account2: '结算单位',
  Oversea: '国内国外',
  Remove: '移除',
  SourceAmount: '原金额',
  NewAmount: '新金额',
  IsUpdate: '是否更新',
  ExportLog: '导出日志',
  Role: '职能',
  Mobile: '手机',
  Email: '邮件地址',
  SOPOperatingState: 'SOP操作状态',
  KG: '公斤',
  CBM: '立方米',
  Tons: '吨',
  SelectOpRequirement: '操作要求选择',
  PleaseInputAKeyword: '请输入关键字检索',
  contentDescription: '内容描述',
  chargeItem: '费用项',
  LCLLastBillOfLading: '拼箱最后提单',
  Addr: '地址',
  HouseNumber: '门牌号',
  Country: '国家',
  Province: '省份',
  City: '城市',
  ZIP: '邮编',
  SelectCharge: '选择费用',
  First: '第一页',
  Pre: '上一页',
  Page: '第',
  AllPage1: '共',
  AllPage2: '页',
  Next: '下一页',
  Last: '最后一页',
  ShowFromTo1: '显示',
  ShowFromTo2: '到',
  AllRecord1: '共',
  AllRecord2: '记录',
  Convert: '折合',
  Received: '实收',
  Paid: '实付',
  AllPositions: '所有岗位',
  DestinationAgent1: '海外代理',
  Accessible: '可访问',
  IsDisplay: '是否显示',
  Uncertain: '未确定',
  PrincipalUnitSOPReceiver: '委托单位SOP接收人',
  PortOfDestinationAgency: '目的港代理SOP接收人',
  DesignatedFreightAgentSOPReceiver: '指定货代理SOP接收人',
  PortOfDepartureAgentSOPReceiver: '起运港代理SOP接收人',
  Unconfirmed: '未确认',
  Confirmed: '已确认',
  PassAudit: '审核通过',
  Refuse: '拒绝',
  Bl: '提单',
  Original: '原始',
  LateOriginal: '晚申',
  Correct: '更正',
  Message: '报文',
  DeleteCustoms: '删除（海关删除，企泰保留）',
  DeleteAll: '删除（企泰海关都删除）',
  send: '发送',
  change: '改单',
  deleteSingle: '删单',
  cancelBill: '撤单',
  OverseasAgeFore: '海外代理预报',
  JclForecast: 'JCL预报',
  AnnPackingList: '安装箱',
  PreShippingBill: '预配舱单',
  PreShippingBillPperation: '预配舱单操作',
  ShippingBill: '舱单',
  Anti_terrorismShipping: '反恐舱单',
  CleanShipping: '清洁舱单',
  Suitcase: '提箱',
  DelSuitcase: '删除提箱',
  ViewHistory: '查看历史',
  ElectronicPackingList: '99路电子装箱单',
  SendHistory: '发送历史记录',
  ShippingSchedule: '船期表',
  PortOfLoadingArea: '起运港港区',
  PortOfDestinationArea: '目的港港区',
  ShipsCallSign: 'EDI船舶呼号',
  ImportTheVoyage: '导入航次',
  IncreaseThePort: '增加港口',
  DeletePorts: '删除港口',
  AutomaticallyImportVoyage: '自动导入航次',
  CountryOfRegistration: '船名注册国',
  AddShippingCompany: '增加船公司',
  DelShippingCompany: '删除船公司',
  DepartureTime: '开船时间',
  DateOfOrder: '接单日期',
  ProjectReceivedBy: '接单人',
  dateOfFiling: '归档日期',
  ArchivePeople: '归档人',
  ReturnOrderExpressNumber: '退单快递号',
  StateOfTheWithdrawal: '状态撤回',
  EmptyTheList: '清空列表',
  BatchStateTransition: '批量状态转换',
  CollectFormation: '收款信息',
  RetreatASingle: '退单列表',
  BatchSaving: '批量保存',
  AppendQueryRecord: '追加查询记录',
  StateHisCase: '提箱状态',
  BoxStatus: '箱状态（仅提供上海港口）',
  StatusOfAnti_TerrorismManifest: '反恐舱单EDI状态',
  ManifestStatus: '舱单EDI状态',
  AdvanceManifestStatus: '预配舱单EDI状态',
  InstallPackingListStatus: '安箱单EDI状态',
  StateOfTheBillOfLading: '提单EDI状态',
  BookingStatus: '订舱EDI状态',
  reset: '重置',
  PrintStatus: '打印状态',
  TeamContact: '车队联系人',
  ContactNumber: '联系电话',
  DoorContact: '门点联系人',
  DoorContactNumber: '门点联系电话',
  PleaseScanTheBarcodeOrInputDirectly: '请扫描条码或直接输入',
  CollectionSituation: '收款情况',
  DocumentDate: '单证日期',
  checkbox: '【多选框】',
  RefundDate: '退税日期',
  RefundPerson: '退税人',
  AutomaticallyRefresh: '自动刷新',
  Piece: '件',
  Volume: '体',
  CartonQuantity: '箱型箱量',
  ClientsRequirement: '客户要求',
  LandCarriage: '陆运',
  HLID: '互联ID',
  ShippingCmp: '船司',
  CarrierSpecificCode: '船司特定代码',
  stationCode: '场站（青岛订阅专用）',
  PortOfLoadingAI: '起运港',
  RiverCarrier: '江船公司',
  Synchronization: '同步',
  BatchShutOut: '批量退关',
  OverseaCustomerService: '海外客服',
  CargoFeature: '货物性质',
  CustomerLevel: '客户级别',
  ContractStatus: '合约状态',
  HBLNotifier: '分单通知人',
  ExportWithSOPToExcel: '导出Excel(含SOP明细)',
  ManagerSubmission: '主管提交',
  CustomerSelfRelease: '客户自出单',
  CompanySelfRelease: '公司自出单',
  QuantitySize: '件数尺寸',
  EquipmentEstimatedReturnTimeFrom: '预计还柜始',
  EquipmentEstimatedReturnTimeTo: '预计还柜至',
  copyDGStuffing: '复制',
  pasteDGStuffing: '粘贴',
  viewDGStuffing: '查看',
  copyAndAddPoItems: '复制新增',
  SynchroHBLInfo: '同步HBL信息',
  Cubage2: '体积M³',
  AMSLog: '日志',
  AMSReceiptInfo: '查看回执',
  ViewAssociatedBusiness: '查看关联业务',
  isShutOut: '是否退关',
  RevokeTuckOrder: '撤单',
  SearchTuckOrder: '查询',
  ShowTuckOrderLog: '日志',
  TuckStatus: '派车状态',
  DriverNameHL: '互联司机',
  DriverPhoneHL: '互联电话',
  TruckNoHL: '互联车牌',
  TmsNoHL: '派车单号',
  ContainerSerialNo: '箱序号',
  ContainerNoDiff: '差异提示',
  isRelated: '是否关联',
  viewDGStuffingInvalid: '作废',
  CommissionedChargedWeight: '委托计费重量',
  CustomsHasCheck: '海关已查',
  CustomsOneRelease: '一次放行',
  CustomsRelease2: '放行',
  PartnerShortType: '类型',
  Transit2: '中转',
  AuditDate: '调整日期',
  IsNeedInvoice: '是否需要开票',
  needInvoice: '需要开票',
  InvoiceNo: '税金号',
  Email2: '邮箱',
  DgconsignParty: 'DGCONSIGN',
  ElseInvoiceParty: 'ELSEINVOICE',
  ShowPODAgency: 'ShowPODAgency',
  FnlTm: '内陆点转运方式',
  InvokeLocalMailClient: '调用本地邮箱',
  preview: '生成附件',
  attachment: '附件：',
  AddPackingInfo: '添加装箱信息',
  RemovePackingInfo: '移除装箱信息',
  sendJdy: '发送简道云',
  sendFailInfo: '发送成功{0}条，失败{1}条：',
  batchSendJdy: '批量发送简道云',
  batchUnlockGoodsDetails: '批量解锁货物明细',
  IdentifyPackingList: '识别装箱单',
  BoxListRecognition: 'AI-箱单识别',
  SupportingUploadFormat: '支持上传的格式pdf/xls/xlsx/doc/docx/jpg/gif/png，单个文件不超过4MB',
  UploadedFile: '已上传文件',
  Parsing: '正在解析',
  SpecialCharactersNotAllow: '文件名称不允许特殊字符',
  MaterialInformation: '物料信息',
  MaterialNumber: '物料号',
  HsCode2: 'HS CODE',
  NetWeightKg: '净重(KG)',
  PONumber: 'PO号码',
  FilePreview: '文件预览',
  MultiCabinets: '多柜',
  CopyDoorPoint: '抄录门点拖柜数据',
  SelectCabinetData: '选择做柜信息',
  ExportPackingInfo: '导出做箱信息',
  ImportPackingInfo: '导入做箱信息',
  ContainerId: '箱ID',
  ContainerSeqNo: '箱序号',
  TrailerRemark: '拖车备注',
  RemarkItems: '备注事项',
  DriverId: '身份证',
  DriverName: '驾驶员',
  DriverPhone: '手机',
  TruckNo: '车牌',
  EstimatArrivalTime: '预计到厂时间',
  DownloadImportResults: '下载导入结果',
  ImportSuccess: '导入成功',
  ImportFaildAndDownFile: '存在导入失败数据集，请下载导入结果查看！',
  SendBack: '退还',
  MSC: 'MSC',
  CompanyInfo: '公司信息',
  LadingBillInfo: '提单信息',
  HV: 'HV',
  RefNo: '参考号',
  DgStuffing: 'DG Stuffing',
  HSCODE: 'HSCODE',
  CustomsCommodity: '报关品名',
  TradeShortName: '货物简称',
  Code3: '代码',
  TradeDescription: '货描',
  ShippingMark: '唛头',
  ZipCode: '邮政编码',
  EmailAddress: '电子邮件',
  VipCode: 'VIP代码',
  InttraCode: 'INTTRA代码',
  MscCode: 'MSC代码',
  CompanyCode: '公司代码',
  LadingBillTitle: '提单抬头',
  LadingBillAddress: '提单地址',
  LadingBillContactInfo: '提单联系信息',
  MstBooking: 'MST BOOKING',
  SplitType: '拆分类型',
  RelatedOrderNo: '相关订单号',
  SignedType: '合约类型',
  FreightTerm: '运费条款',
  PlaceOfPayment: '付款地点',
  ProductionInstallationPlace: '产装地',
  ProductionInstallationPlaceStation: '产装地场站',
  ProductionInstallationModeOfTransportation: '产装运输方式',
  PortOfLoadingWharf: '起运港码头',
  PortOfDischargeWharf: '卸货港码头',
  PortOfDischargeRequire: '卸货港要求',
  Destination: '目的地',
  DestinationStation: '目的地场站',
  DestinationTransportWay: '目的地转运方式',
  TransferCountry: '中转国',
  BlNumber: 'BL NUMBER',
  FreightBL: 'Freight BL',
  PODAgency: 'POD Agency',
  MscServiceCode: '服务代码',
  ToOrderType: 'TO ORDER TYPE',
  DestinationZipCode: '目的地邮编',
  CopyCompany: '公司信息抄录',
  ChargeImport: '费用导入',
  customerLevel: '客户级别',
  isSignContract: '是否签约',
  RemovePacking: '移除装箱',
  LastContainerDescription: '最后货描',
  SelectLocation: '选择地点',
  GetBack: '取回',
  CancelGetBack: '撤销取回',
  Releasing: '放单',
  CancelReleasing: '撤销放单',
  StatusModefySuccessfully: '状态修改成功',
  BillingOfLadingRecordManager: '提单日志',
  ApplyForARelease: '申请放单',
  RequestReleaseBy: '申请放单人',
  TicketHasSplit: '此票已拆单，请在拆单中提交申请',
  TicketHasMerged: '此票已并单，请在并单中提交申请',
  RequestReleaseDate: '申请放单日期',
  RequestReleaseState: '申请放单状态',
  MblRequestReleaseState: 'MBL申请放单状态',
  HblRequestReleaseState: 'HBL申请放单状态',
  NotApplying: '未申请',
  Requested: '已申请',
  NoGuarantee: '无保函',
  InEffect: '生效中',
  Expired: '已失效',
  Uploaded: '已上传',
  NotUploaded: '未上传',
  NoUploadRequired: '无需上传',
  NotUploadedYetPlease: '尚未上传，请',
  LongTermGuaranteeState: '长期保函状态',
  SingleTicketGuaranteeState: '单票保函状态',
  WithdrawTheRequestForRelease: '撤回申请放单',
  NoRequestReleaseData: '没有需要申请放单的数据',
  NoCancelRequestReleaseData: '没有需要撤回申请放单的数据',
  ReleasingDate: '放单日期',
  mblReleasingDate: 'MBL放单日期',
  receiptDate: '时间',
  receiptContent: '内容',
  receiptCode: '回执代码',
  createdDate: '时间',
  createdBy: '操作人',
  content: '内容',
  consignorCode: '发货人企业代码',
  codeAbbreviation: '代码缩写',
  enterpriseCode: '企业代码',
  consignorName: '发货人企业名称',
  consignorDetailAddress: '发货人详细地址',
  consignorPhone: '发货人电话号码',
  consignorEmail: '发货人EMAIL地址',
  consignorRelexNumber: '发货人电传号码',
  cityName: '城市名称',
  consignorCityName: '发货人城市名称',
  provinceCode: '省份代码',
  provinceName: '省份名称',
  postalCode: '邮政编码',
  countryCode: '国家代码',
  aeoEnterpriseCode: 'AEO企业编码',
  formatSynchronizeToOrder: '同步格式化信息至订单',
  ladingBill: '指示提单',
  consigneeCode: '收货人企业代码',
  consigneeCodeAbbreviation: '代码缩写',
  consigneeEnterpriseCode: '企业代码',
  consigneeName: '收货人企业名称',
  consigneeDetailAddress: '收货人详细地址',
  consigneePhone: '收货人电话号码',
  consigneeEmail: '收货人EMAIL地址',
  consigneeRelexNumber: '收货人电传号码',
  consigneeCityName: '城市名称',
  consigneeProvinceCode: '省份代码',
  consigneeProvinceName: '省份名称',
  consigneePostalCode: '邮政编码',
  consigneeCountryCode: '国家代码',
  consigneeAeoEnterpriseCode: 'AEO企业编码',
  specificContactName: '具体联系人名称',
  specificContactPhone: '具体联系人电话号码',
  specificContactAddress: '具体联系人EMAIL地址',
  specificContactRelexNumber: '具体联系人电传号码',
  notifyingCode: '通知人企业代码',
  notifyingCodeAbbreviation: '代码缩写',
  notifyingEnterpriseCode: '企业代码',
  notifyingName: '通知人企业名称',
  notifyingDetailAddress: '通知人详细地址',
  notifyingPhone: '通知人电话号码',
  notifyingEmail: '通知人EMAIL地址',
  notifyingRelexNumber: '通知人电传号码',
  notifyingCityName: '城市名称',
  notifyingProvinceCode: '省份代码',
  notifyingProvinceName: '省份名称',
  notifyingPostalCode: '邮政编码',
  notifyingCountryCode: '国家代码',
  notifyingAeoEnterpriseCode: 'AEO企业编码',
  formatManifestInformation: '格式化舱单信息',
  freightChargesInfo: '费用信息',
  freightChargesUSDTotal: 'USD费用合计:',
  tips: '提示!',
  checkNominatedAgent: '指定货代理不能为空！',
  checkActualNotifyParty: '实际通知人不能为空！',
  checkConsignationCompany: '委托单位不能为空!',
  checkLoadingPort: '装货港不能为空!',
  checkLoadingPort2: '起运港不能为空!',
  checkPortOfDischarge: '卸货港不能为空!',
  checkPlaceOfDelivery: '交货地不能为空!',
  checkFinalDestination: '最终目的地不能为空!',
  checkDateOfDepartureAndDateOfArrival: '开航日期不能晚于到港日期！',
  checkSales: '销售不能为空!',
  checkDept: '部门不能为空!',
  searchInfo: '没有输入查询信息！',
  checkVslVoy: '船名或航次不能为空.',
  prePlanBooking: '预配信息',
  VgmInfo: 'VGM信息',
  ChooseSoNoInfoToCopy: '请勾选关单信息进行复制~',
  ChooseContainerInfoToCopy: '请选择箱子信息进行复制~',
  manifestLinkCopy: '复制舱单链接',
  manifestInviteSupplement: '邀请补充舱单',
  manifestQueryLog: '舱单回执',
  manifestCfmStateLog: '舱单状态',
  manifestByPreShipping: '预配舱单',
  manifestByClearBooking: '清洁舱单',
  manifestCfmButton: '确认',
  manifestUnLockButton: '临时解锁',
  HBLWeight: '提单毛重',
  HBLQuantity: '提单件数',
  BillPortOfLoading: '提单起运港',
  BillPortOfDischarge: '提单卸货港',
  BillPlaceOfDelivery: '提单交货地',
  UserDefinedField1: '自定义字段1',
  UserDefinedField2: '自定义字段2',
  UserDefinedField3: '自定义字段3',
  UserDefinedArea: '自定义信息',
  PleaseAddConsigneeFirst: '请先添加CONSIGNEE',
  CopyConsigneeToNotify1: '复制CONSIGNEE',
  OnlyOne: '只能选择一个',
  CopyPoItemInfo: '箱货信息复制',
  CopySuccess: '复制成功',
  CopyFaild: '复制失败',
  PaseteSuccess: '粘贴成功',
  NoPasetePoItemInfo: '未复制箱货信息，请先复制.',
  IsOrNotSpelling: '是否加拼？',
  Insure: '投保',
  billPaymentNo: '付款申请单号',
  confirmUser: '费用确认人',
  ediFeedBackState: '回执日志',
  receiptPrompt: '提示：发送舱单20天内的数据，系统会自动获取回执。',
  loadingManifestReceipt: '装载舱单回执',
  customsReceipt: '海关总署舱单',
  receiving: '正在回执',
  receiptSucceeded: '回执成功',
  receiptFailed: '回执失败',
  customCode: '关区代码',
  transportation: '运输方式',
  receiptBillType: '提运单类型',
  transportationName: '运输工具名称',
  receiptVoyage: '航班/航次',
  importArrivalSignal: '进口抵港确报标志',
  receiptBillNumber: '建造单',
  entryDepatureDate: '进入境日期',
  itemCount: '件数',
  kilogram: '千克',
  receiptWeight: '数量',
  tallyStatus: '理货状态',
  exportArrivalStatus: '出口运抵状态',
  sendLog: '发送日志',
  ediStatus: 'EDI状态',
  ManifestDeliveryStatus: '舱单发送状态',
  chooseShipper: '选择发货人',
  chooseConsignee: '选择收货人',
  chooseNotify: '选择通知人',
  bulkReplication: '批量复制',
  PlannedDepartureTime: '计划发车时间',
  ActualDepartureTime: '实际发车时间',
  PlannedArrivalTimeAtTheFactory: '计划到达工厂时间',
  RealTimeOfArrivalAtTheFactory: '实际到达工厂时间',
  PlannedTimeToLeaveTheFactory: '计划离开工厂时间',
  ActualTimeToLeaveTheFactory: '实际离开工厂时间',
  PlannedArrivalTime: '计划到达时间',
  ActualArrivalTime: '实际到达时间',
  currentLocation: '当前位置',
  ViewExceptions: '查看异常',
  truckingPlaceDep: '提柜堆场',
  truckingPlaceDest: '还柜堆场',
  travelTime: '在途时间',
  Hour: '小时',
  Minute: '分钟',
  salesOffice: '销售分公司',
  opOffice: '操作分公司',
  BookingAgentIsNull: '订舱代理为空',
  SOPReceiver: 'SOP接收人',
  Collectioninformation: '收款信息',
  Appendqueryrecord: '追加查询记录',
  SalesOfGoods: '揽货销售',
  BatchProcessing: '批量处理',
  ClickSpaceToDropDownOptions: '敲空格可下拉选项',
  PleaseMaintainTheCorrespondingSalesInThePartner: '请至合作伙伴维护',
  CheckRecordedCustomsDeclaration: '报关单放行通知查询',
  ClearPacking: '清空装箱',
  CopyMarksFromReceipt: '取小票唛头',
  PODCountry: '目的港国家',
  Details: '详情',
  import: '导入',
  DangerousClass: '危险品等级',
  DangerousGoodsContact: '危险品联系人',
  DangerousGoodsContactPhoneNumber: '危险品联系人电话',
  emptyBox: '空箱',
  ShipperByCompany: '发货人（公司信息）',
  ConsigneeByCompany: '收货人（公司信息）',
  PreverifyStatus: '预审状态',
  ChangeCommit: '提交改单费用',
  ConfirmChangeCommit: '确定要提交改单费用吗?',
  UserDefinedField4: '自定义字段4',
  BoardSales: '打板系统销售',
  BoardCsr: '打板系统客服',
  BoardSite: '打板系统站点',
  ArrivalMethod: '到货方式',
  FlightLabel: '空运标签',
  bargePOL: '驳船起运港(POL)',
  SalesRequire: '销售要求',
  OnlyDisplayTicket: '仅显示满足条件的小票',
  batchImportCharge: '批量导入费用',
  importCharge: '导入费用',
  historyLogQuery: '历史日志查询',
  noRule: '编号规则',
  MBLNO: 'MBL NO',
  importSetting: '导入设置',
  receivable: '应收',
  payable: '应付',
  importFile: '导入文件',
  confirmImport: '确认导入',
  checkLines: '行数不能超过1000行',
  checkLines200: '行数不能超过200行',
  checkChargeInfo: '请输入费用的相关信息再做导入操作！',
  internal: '国内',
  overseas: '国外',
  batchOperate: '批量操作',
  batchImport: '批量导入',
  activity: '流程',
  JobInfo: '业务信息',
  Service: '服务',
  Supplier: '供应商',
  InnerInfo: '内部信息',
  Defined: '自定义',
  MoreInfo: '更多信息',
  unDisplayInfo: '隐藏信息',
  GeneralInfo: '小票信息',
  BatchModifiedState: '批量修改状态',
  SplitTicketsInfo: '分票信息',
  destinationStation: '目的站',
  departureStation: '始发站',
  transitStation: '过境站',
  destinationStationRailport: '目的站(铁路)',
  departureStationRailport: '始发站(铁路)',
  transitStationRailPort: '过境站(铁路)',
  CommonInfo: '常规信息',
  settlementAgent: '结算代理',
  Dimension: '尺寸CM(长*宽*高)',
  PaymentType: '预付/到付',
  ToPay: '到付',
  PrePay: '预付',
  PickUpGoods: '是否提货',
  DocumentationNumberOfPackages: '制单件数',
  DocumentationGrossWeight: '制单毛重',
  DocumentationVolume: '制单体积',
  DocumentationChargedWeight: '制单计费重量',
  CustomerQuantity: '客户件数',
  CustomerGrossWeight: '客户毛重',
  CustomerVolume: '客户体积',
  CustomerChargedWeight: '客户计费重量',
  VerifyReviewThrough: '复核通过',
  VerifyReviewRefusal: '复核拒绝',
  ImportTime: '导入时间',
  descr: '备注说明',
  logFile: '日志文件',
  ChargeBranchId: '所属分公司',
  DateCreated: '录入日期',
  ProfitOwner: '利润所属方',
  ScfiDeclare: 'SCFI申报',
  ScfiPrice: 'SCFI运价',
  Copy: '复制',
  ImportOrder: '导入订单数据',
  ImportBusinessNo: '导入业务编号',
  SelectOrderNumber: '选择订单编号',
  ArrivalTime2: '运抵目的地日期',
  ProjectName: '项目名称',
  ProjectBatch: '项目批次',
  CargosExpectedArrivalDateByTrucking: '预计到货日期(客户门点)',
  CargosExpectedArrivalDateWarehouseLoading: '预计到货日期(仓库内装)',
  CargosExpectedArrivalDatePacking: '预计装箱日期',
  EstimatedPackTheCabinetTime: '预计装柜时间',
  MaintainJobNoRule: '请维护工作号编码规则！',
  SelectCodeRule: '请选择编码规则',
  CodeRuleDesc: '编码规则说明',
  SpecifyAgentNumber: '指定货代理数',
  CustomsClearanceChargeRelatedEdit: '有费用退关只可作费用相关更改',
  CustomsClearanceNoChargeNoChange: '无费用退关不可作任何更改(所有费用会被删除)',
  ClearFeeNoChargeCustomsClearance: '无费用退关如果不清除已确认费用，不可无费用退关。',
  VotesPreSubmission: '票进行预提交吗?',
  AllNotPositiveOperationStatus: '选择的数据记录全部为非【正操作】状态',
  AllNotToVerifyStatus: '选择的数据记录全部为非【待审核】状态',
  ContainerLoadTypeNotCorrect: '该票业务整拼类型不是自拼箱、buyer consol、委托拼箱',
  RecordNotPositiveOperationStatus: '该票业务不是“正操作”状态',
  RailwayCheckLob: '所选Job存在不同业务类型，请选择相同业务类型再试。',
  TheTicketIsMain: '该票业务为主票',
  TheTicketAssociatedMain: '该票业务已关联主票',
  TheTicketAssociatedContainerInfo: '该票业务已关联装箱信息',
  ContainerLoadTypeIs: '整拼类型已为',
  NoneModified: '无需修改',
  ContainerLoadTypeBatchModifySuccess: '批量修改整拼类型成功:',
  NoDataProcessed: '无已处理的数据',
  CustomsInformation: '报关资料',
  AddFile: '添加文件',
  CustomsReceiptFile: '海关回执文件',
  CustomsReceiptState: '海关回执状态',
  CloneCabinBerth: '复制舱位',
  BackFillCabinBerth: '舱位回填',
  GenerateBusiness: '生成业务',
  ReturnCabin: '退舱',
  CheckBeforeEntrust: '您委托的{0}没有维护{1}的SCAC码等相关信息，请跟对方核对后再进行委托！',
  CheckPortBeforeEntrust: '您委托的【{0}】没有维护【{1}】港口，请跟对方核对后再进行委托！',
  CheckPackBeforeEntrust: '您委托的【{0}】没有维护【{1}】包装，请跟对方核对后再进行委托！',
  PortDataPushLog: '港区数据推送日志',
  EdiStatusChangeLog: 'EDI状态变更日志',
  BookingReceiptLog: '订舱回执操作日志',
  MergeAndSingle: '并单',
  OuJianDeclaration: '欧坚报关',
  AirportPort: '机场口岸',
  Airport: '机场',
  GoodsStoragePlace: '货物存放地',
  ExchangeServiceAi: '是否需要报关行抽单服务',
  DataPushChangeLog: '数据推送变更记录',
  SendBookingData: '发送订舱数据',
  SelectAction: '选择操作',
  IsGroupBranch: '是否集团分公司',
  SmtpServerError: 'SMTP服务器错误',
  NotConnectSmtpServer: '不能连接SMTP服务器',
  NotFindFile: '系统找不到指定文件',
  SendFileError: '发送文件出错',
  AttachTemplateError: '附件模板出错',
  MailSentSuccess: '邮件发送成功',
  PleaseSelectAction: '请选择操作',
  PleaseSelectCategory: '请选择货物大类',
  PleaseSelectOpDep: '请选择操作部门',
  SeaExportLetter: '海运出口货运委托书',
  DataPush: '数据推送',
  MasterTicketSync: '主票同步',
  BookingDataSentSuccess: '订舱数据发送成功!',
  CostSettlementObjectBlocked: '费用的结算对象[{0}]已被屏蔽可能存在风险，是否继续保存？',
  ConsigneeRequired: '请输入HB/L界面收发通信息！',
  OverseaCustomerUpdate: '原海外客服[{0}]已失效，是否更新为新海外客服[{1}]',
  ConatainerNoRemoveRelation: '箱号为{0}的数据都会被移除关联，需要继续吗',
  EDIBooking: 'EDI订舱',
  EDIContainers: '装箱信息EDI',
  ContainersLog: '装箱信息回执日志',
  PleaseSelect2: '请选择要发送的业务！',
  MingShen: '民生',
  MingShenCompany: '民生国际船务代理有限公司',
  EDIDoc: 'EDI提单',
  RoundPaymentAmountExchangeRate: 'ROUND(付汇金额*付汇汇率)',
  VGMIsEmpty: 'VGM为空！',
  VGMRaw: 'VGM原始',
  VGMCorrection: 'VGM更正',
  FileOnlyXlsXlsx: '上传文件只能是 xls、xlsx格式!',
  FileOnlyXlsx: '上传文件只能是xlsx格式!',
  stayTuned: '敬请期待',
  UploadImageFormatWrong: '上传的图片格式错误，现阶段我们支持的图片格式为：PNG、JPG、JPEG，请进行转码或更换图片',
  ItIsEmpty: '为空',
  AdvancePayment_ActualAmount_HandlingCharge_PostTelecommunicationCharge_AcceptanceHandlingCharge: '付汇预款项(RMB)-实际付汇金额(RMB)-手续费(RMB)-邮电费(RMB)-承兑手续费(RMB)',
  RelatedBusinessNoSpecial: '关联业务暂无特殊货物信息',
  ReceiptImportFailed: '回执单导入失败!',
  ReceiptImportedSuccessfully: '回执单导入成功!',
  ReceiptImport: '回执导入',
  CopyLinkPublic: '复制链接(公共)',
  CopyLinkPromissoryNote: '复制链接(本票)',
  RepeatBoxType: '存在两条相同箱型箱种记录',
  RepeatUldType: '已存在一条相同集装器代码的记录！',
  RealDepartureTime: '实际离泊时间',
  RealDeparture: '实际离泊',
  ActualBerthingTime: '实际靠泊时间',
  ImportFailedContactAdministrator: '导入失败，请联系管理员。',
  ContractPeriod: '合作伙伴： ${0} 存在有效期内的合同，请至【合同管理】内调整对应的信用账款。',
  HasBeenSelected: '已经被选择',
  HasExceeded: '已经超出!',
  HasExceededCannotEDI: '已经超出,不能EDI!',
  UnloadingPortNotMaintain: '当前"委托单位"的该"卸货港"未维护相应代理，是否清空已选择的指定货代理和销售信息？',
  EnYuanHuaXiaKu: '恩原华夏库',
  EnyuanYangyuanKu: '恩原杨园库',
  EnyuanGaoxiangku: '恩原高翔库',
  NotInsuranceOperationPermission: '您没有[投保]操作权限！',
  CorrectionBillOfLading: '提单更正',
  ConfirmationBillOfLading: '提单确认',
  Tips: '提示！',
  PickUpTypeDifferentSmallTicket: '提货类型与小票不相同，确认要保存吗？',
  OperationDepartmentCannotBeEmpty: '操作部门不能为空.',
  FileContentIsEmpty: '文件内容为空',
  FileContentWrong: '文件内容有误',
  FileSizeCannotLargerThan2MB: '文件大小不能大于2MB',
  NoData: '无数据',
  NoBusinessSelected: '未选择业务.',
  OriginalNormal: '正本',
  NoImportEDI: '此单没有可导的EDI',
  PackingDataNotCconsistent: '此工作单装箱数据与实际数据不符，请核对装箱信息！',
  CreditControlTheClient: '此票委托单位的信控',
  SaveBusinessBeforeEnterMultiGate: '录入多门点，请先保存业务',
  SaveBusinessBeforeEnterMultiGate2: '注：录入多门点或多柜，请先保存业务',
  BookingWorkspace_PrePlan_ImportExcel: '海运订舱极速版-预配信息-导入Excel',
  SpecialCargoNumber: '特殊货物编号',
  RelevantTicketsResetAndUpdated: '确认后相关小票将重置并更新，是否同步？',
  ManifestConfirmed: '舱单已确认！',
  ManifestDataIsEmpty: '舱单数据为空！',
  ManifestConfirmationFailed: '舱单确认失败！',
  NodeTriggerFailed: '节点触发失败!',
  LoadingOfPackingInformationFailed: '装箱信息加载失败。',
  PlanDepartureTime: '计划离泊时间',
  PlannedBerthingTime: '计划靠泊时间',
  OriginalPlanDepartureTime: '原始计划离泊时间',
  OriginalPlannedBerthingTime: '原始计划靠泊时间',
  NowPlanDepartureTime: '当前计划离泊时间',
  NowPlannedBerthingTime: '当前计划靠泊时间',
  CurrentETA: '当前计划到港时间',
  OriginalETA: '原始计划到港时间',
  CurrentETA1: '当前计划到港时间（Current ETA）',
  OriginalETA1: '原始计划到港时间（Original ETA）',
  ShippingScheduleNew: '船期导入模板(新版)',
  ShippingScheduleold: '船期导入模板(旧版)',
  ImportNew: '导入(新版)',
  ImportOld: '导入(旧版)',
  PlannedBerthing: '计划靠泊',
  PlanDeparture: '计划离泊',
  BookingEDI: '订舱EDI',
  BookingCorrection: '订舱更正',
  PortMaintainedDesignatedFreightForwarder: '该港口已经维护相应的指定货代理，是否使用该港口维护的指定货代理？',
  MBLStatusNotIsUnStart: '该票MBL对单状态不是未开始，无法导入。',
  PrimaryOrderNotSameReceipt: '该票业务主单号与回执单主单号不一致，是否继续导入？',
  RequestSuccessful: '请求成功！',
  SpecialCharacters: '存在特殊字符，无法发起订阅港区或者船公司数据',
  EnterReleaseNumber: '请输入放单号',
  SelectAPieceOfData: '请选择一条数据！',
  SelectARecord: '请选择一条记录！',
  ChooseDesignatedAgent: '请选择指定货代理!',
  ChooseSpecialGoods: '请选择特殊货物!',
  CargoInformationIsEmpty: '货物信息为空.',

  InviteSupplementaryLinksPublic: '邀请补充链接(公共)',
  InviteSupplementaryLinkPromissoryNote: '邀请补充链接(本票)',
  DownloadCWTemplate: '下载CargoWare模版',
  DownloadCWTemplateJC: '下载CargoWare模版（锦昶）',
  DownloadSeaHouseTemplate: '下载海管家模板',
  DownloadWseTemplate: '下载CargoWare模板（青岛）',
  DownloadWseTemplateSh: '下载CargoWare模板（上海）',
  ExportSinO56TemplateNb: '导出SINO56模板（宁波）',
  DownloadWseTemplateVgm: '下载未斯模板',
  SendingChannelVgm: '发送渠道',
  MailSendingFailed: '邮件发送失败!',
  DistributionFailed: '配货失败',
  SalesAndOperationAreSame: '销售和操作相同，确认要保存吗？',
  PreConfiguredManifestAPI: '预配舱单API',
  PreConfiguredManifestDeletion: '预配舱单删除',
  PreConfiguredManifestIsEmpty: '预配舱单删除对象为空,请刷新页面后重试',
  CorrectionOfPreAllocatedManifest: '预配舱单更正',
  OperationFailed: '操作失败！',
  RedOffsetCannotModified: '红冲费用或者被红冲费用不能再次修改，请选择增加调整.',
  RedOffsetCannotDeleted: '红冲费用或者被红冲费用不能被删除，请重新选择',
  MaintainNodeDetailCode: '请维护节点详情代码',
  DeleteNumRecord: '确定要删除这{0}条记录吗？',
  DeleteNumFile: '确定要批量删除这{0}个文件吗？',
  ClickYesRetrievedToReturnedStatus: '单击"是"将跳转到打印页面,"已取回"的单证改为"已退还"状态。',
  ClickYesToReturnedStatus: '单击"是"将跳转到打印页面并修改单证为"已退还"状态。',
  FileNotAllowedView: '{0}文件不允许任何人查看或下载.',
  NoPermissionToView: '你没有权限查看或下载[{0}]文件',
  UploadFailed: '上传失败！',
  UploadSuccess: '上传成功！',
  UploadSuccessNoOrder: '上传成功，未找到相关订单！',
  UploadedFileNotMatch: '上传文件的类型不匹配,请检查！',
  UploadType: '上传类型',
  FileSource: '文件来源',
  ReceiptType: '回执类型',
  SendAisle: 'EDI通道',
  BusinessNotSubmitted: '业务未提交,不能退单',
  BusinessNotBeenApproved: '业务还没有被审核，确认要退还吗？',
  NoPermissionToViewOrprinted: '你没有查看其它人上传或者打印的文件的权限.',
  DocumentDelivery: '单证送出',
  SameStatusCanBePrinted: '只能打印相同状态的单证!',
  ReceiptContent: '回执内容',
  ReceiptTime: '回执时间',
  PrintCommonControls: '打印公共控件',
  CustomsBrokerOthers: '报关行/其他',
  ReceiveReceiptTime: '接收回执时间',
  ReceivingAddress: '收件地址',
  bookingParty: '订舱单位',
  BusinessIsLocked: '该业务已被锁定,不能退单',
  ConfirmUploadFileType: '请确认上传文件类型,是否继续上传?',
  InputCustomerName: '请输入客户名称!',
  InputExpressNumber: '请输入快递单号!',
  InputExpressAddress: '请输入快递地址!',
  InputRecipient: '请输入收件人!',
  InputRecipientName: '请输入收件人名称!',
  InputReceivingcompany: '请输入收件单位!',
  InputReceivingAddress: '请输入收件地址!',
  InputContactNumber: '请输入联系电话!',
  InputContactNumberMark: '请输入联系电话！',
  InputReturnExpressNumber: '请输入退还快递号!',
  ReturnInformation: '返回信息',
  ReturnDateGreaterThanRetrieveDate: '退还日期必须大于取回日期!',
  DateModified: '更新时间',
  OperationCannotBeEmpty: '操作不能为空.',
  OperationCompanyCannotBeEmpty: '操作公司不能为空.',
  BookingAudit: '订舱审核',
  UseThisNo: '使用本编号',
  WarehousingFee: '仓储费',
  BookingSuccess: '订舱成功',
  ToBeConfirmed: '订舱待确认',
  BookingFail: '订舱失败',
  CabinState: '舱位状态',
  CostGenerationMethod: '费用生成方式',
  SettlementInPriginalCurrency: '按原币种结算',
  SettlementInBillCurrency: '按账单币种结算',
  ShowDetails: '显示详细信息',
  ImportResultLog: '导入结果日志',
  ImportComplete: '导入完成',
  SuccessItemFailedItem: '成功【{0}】条，失败【{1}】条。',
  ContinueImporting: '继续导入',
  DownloadResultLog: '下载结果日志',
  PONo: 'PO 号',
  VoyageOnlyNum: '航次只能输入数字或字母.',
  UpdateSuccess: '变更成功.',
  ShippingSpace: '舱位',
  RejectTips: '确认要拒绝{0}通过审核吗？请输入拒绝理由：',
  GenerateBusinessTips: '是否确认生成业务？（生成后不可撤销）',
  ReturnedShipping: '是否确认已退舱？（记录退舱后不可撤销）',
  ReturnedShippingSuccess: '退舱成功',
  ShippingCompanyAndBookingAgent: '请输入对应的船公司和订舱代理',
  CabinCopySuccess: '舱位复制成功，新业务编号为：',
  CheckShippingCompanyAndBookingAgent: '船公司和订舱代理不可只填一项',
  ReviewRejectedSuccess: '复核拒绝成功',
  ReviewSuccess: '复核成功',
  BatchReviewSuccess: '批量复核成功',
  CheckBatchReview: '批量复核业务不能超过50条！',
  RefuseSuccess: '拒绝成功',
  BatchAuditSuccess: '批量审核成功',
  AuditSuccess: '审核成功',
  CheckCreditTipOne: '以下业务的委托单位已超信控，不可审核通过',
  CheckCreditTipTwo: '以下业务的委托单位已超信控，确认要审核通过吗？',
  BatchAuditBusinessTip: '批量审核业务不能超过50条！',
  CheckCreditSaveTip: '由于信控超出,本票已被锁定,将不能打印或者EDI,请需要时联系上级解锁!',
  CabinCopy: '复制舱位',
  EnterShippingCompany: '请在【舱位{0}】中输入船公司',
  EnterBookingAgent: '请在【舱位{0}】中输入订舱代理',
  EnterEtd: '请在【舱位{0}】中输入开航日期',
  CheckEnterShippingCompanyBookingAgentEtd: '请输入舱位对应的船公司、订舱代理、开航日期',
  UnreviewedBusinessNumber: '未审核的业务编号：{0}',
  UnreviewedBusinessNumber2: '未审核的委托编号',
  DateOfCreation2: '创建时间',
  plateNumberAndMblCannotBeEmpty: '车牌号和提单号不能为空',
  ActualDateOfDeparture: '实际开航日期',
  ActualDateOfDeparture2: '实际开航日期(ATD)',
  nameOfVesselCannotBeEmpty: '船名不能为空.',
  voyageNumberCannotBeEmpty: '航次不能为空.',
  shippingCompanyCannotBeEmpty: '船公司不能为空.',
  MasterShippingCompanyCannotBeEmpty: '主船公司不能为空',
  hasBeanSend: '已发送',
  notSend: '未发送',
  UpdateTime: '更新时间',
  CategoryOfGoods: '货物大类',
  ShipperLine1: '发货人第一行',
  ConsigneeLine1: '收货人第一行',
  NotifyPartyLine1: '通知人第一行',
  CargoDocShipperLine1: '提单发货人第一行',
  CargoDocConsigneeLine1: '提单收货人第一行',
  CargoDocShipper: '提单发货人',
  CargoDocConsignee: '提单收货人',
  CargoDocNotify: '提单通知人',
  CargoDocNotifyPartyLine1: '提单通知人第一行',
  MBLBillOfLadingNum: '主单流水号',
  HBLBillOfLadingNum: '分单流水号',
  RegularBusiness: '转正式业务',
  InputDate2: '录入日期',
  ExpectedArrivalDate: '预计到港日期',
  PleaseChooseEtdStartDate: '请选择ETD开始日期.',
  PleaseChooseEtdEndDate: '请选择ETD结束日期.',
  VOYAGE_NUMBER_ALERT: '请填写航次号.',
  voyageNumberRepeat: '航次不可重复.',
  DirectOrderOrNot: '是否直单',
  EDICode: 'EDI代码',
  MSCVesselImport: '导入MSC',
  MSCEDIExport: 'MSC Vessel CODE',
  pleaseDelEmptyCarrierRecord: '船公司记录不能为空.',
  CannotBeTheSame: '共舱船公司不能跟主船公司相同',
  PortNotNull: '存在有港口为空的数据，所有航次的的港口都不能为空',
  PortDuplication: '港口不能重复',
  EtdAndEtaNotNull: 'Original ETA 和 Original ETD 不能都为空',
  shipNameCannotBeEmpty: '船名的中文名或英文名不可为空.',
  EnglishShipNameCannotBeEmpty: '英文船名不可为空',
  alreadyExistsShipNameAndContinueToSave: '已有相同的船名的中文名或英文名,是否继续保存?',
  ExportAllToExcel: '全部导出Excel',
  FlightAndTime: '航班/次',
  exportThisPageEdi: '导出本页EDI',
  ExportAgentList: '导出代理清单',
  ContinueToExport: '继续导出',
  OnlyMainTicketAndFCLServicesCanBeExported: '只有主票和整箱业务可导出您勾选的业务均不可导出',
  IgnoresNonExportableServices: '只有主票和整箱业务可导出系统将自动忽略不可导出的业务是否继续导出？',
  ExportSuccess: '导出成功',
  voyageShippingCompanyCanNotNull: '航次的船公司不能为空',
  PleaseSelectShippingName: '请选择船名',
  DownloadTemplate: '下载模板',
  BLForm: '提单形式',
  FreeDetention: '免柜租期',
  FreeDemurrage: '免堆天数',
  CustomsAreaApplication: '关区申请',
  SettlementCompanyNotEmpty: '结算部门不能为空!',
  StartMbl: '主单号前缀',
  EndMbl: '结束主单号',
  BillOfLading: '提货单号',
  CartonQuantityCannotBeZero: '箱量不能为空!',
  DistributionNo: '分拨单号',
  DistributionWarehouse: '分拨仓库',
  PreDateOfCustomsDeclaration: '预报关日期',
  sendFailed: '发送失败',
  SelfDeclaration: '自报关',
  FilingType: '申报类型',
  emailAccount: '申报账户',
  secondGeneration: '二代 注：二代必须填写加拿大海关备案号',
  CanadianCustomsRecordNumber: '加拿大海关备案号',
  ExchangeService: '是否需要报关行换单服务',
  SpecialRelationshipOfBuyer: '买卖双方是否特殊关系',
  IncludeRoyalty: '是否含有特许权使用费',
  AffectPrice: '是否影响价格',
  WoodPacking: '是否木包装',
  Combination: '组合',
  Split: '拆分',
  FinalStepSync: '是否尾程同步',
  FinalStepSyncBtn: '尾程同步',
  Synced: '已同步',
  NotSynced: '未同步',
  PleaseSelectSyncOrder: '请选择需要同步的订单',
  PleaseFillLastMilePlanner: '请填写尾程商务负责人',
  PleaseSelectNotSyncedOrder: '请选择未同步的订单',
  FinalStepSyncSuccess: '成功同步{0}条',
  CombinationJob: '组合业务',
  ReceivableChargeLockedStatus: '应收费用锁定状态',
  PayableChargeLockedStatus: '应付费用锁定状态',
  NotLocked: '未锁定',
  ChargeLocked: '应收费用或应付费用已被锁定，不能进行此操作！',
  ArChargeLocked: '应收费用已被锁定，不能进行此操作！',
  ApChargeLocked: '应付费用已被锁定，不能进行此操作！',
  LockedStatus: '锁定状态',
  LockedDate: '锁定时间',
  LockAr: '锁定应收',
  UnLockAr: '撤销锁定应收',
  LockAp: '锁定应付',
  UnLockAp: '撤销锁定应付',
  importExpenseStatus: '导入后费用状态',
  accountingDate: '导入后财务日期',
  BatchReturnSubmit: '批量撤回提交',
  BatchReturnPreSubmission: '批量退回预提交',
  BatchUnlockReceivableExpenses: '批量解锁应收费用',
  BatchUnlockPayableFees: '批量解锁应付费用',
  UnlockApplyBtn: '申请解锁',
  UnlockApplyTitle: '费用解锁申请',
  UnlockApplyJobCount: '本次申请订单数：{0}',
  UnlockApplyCountLimitTip: '单次最多200单',
  UnlockApplyReason: '解锁申请原因',
  UnlockApplyReasonPlaceholder: '请输入解锁申请原因',
  UnlockApplyReasonRequired: '请输入解锁申请原因',
  UnlockApplyReasonOverLength: '解锁申请原因不能超过500字',
  DeclaredProfitImpact: '申报毛利影响金额',
  UnlockApplyAmountRequired: '请输入申报毛利影响金额',
  UnlockApplySubmit: '提交申请',
  UnlockApplyPrecheckFailed: '校验未通过，以下订单不可发起，请调整后重试：',
  UnlockApplyFailureReason: '失败原因',
  UnlockApplyOnlySeaExport: '仅海运出口订单可发起',
  UnlockApplyOverLimit: '单次操作不能超过200票',
  UnlockApplyChargeNotLocked: '应收/应付费用均未锁定，无需申请解锁',
  UnlockApplyJobNotLocked: '当前订单未锁定，不能申请解锁!',
  UnlockApplyJobStateInvalid: '选中的订单中存在状态不为 已审核 的订单，请检查!',
  UnlockApplySubmitted: '申请已提交，批次号：{0}',
  UnlockApplyApproving: '解锁审批中',
  UnlockApplyUnlocking: '解锁中',
  UnlockApplyUnlockedBanner: '该订单费用已解锁可修改，将于3天后01:00自动重锁',
  BatchLockingReceivableExpenses: '批量锁定应收费用',
  BatchLockingPayableFees: '批量锁定应付费用',
  ReplaceSOPTemplatesInBatches: '批量更换SOP模板',
  BatchUpdateScNo: '批量修改约号',
  BatchUpdateScNoSuccess: '批量修改约号成功：{0}',
  BatchUpdateScNoCheck: '只能批量更改正操作的单子。',
  BatchReturnSubmitCheck: '只允许取消业务状态为已提交的单子。',
  MasterChargeIsShare: '主票费用是否分摊',
  PackageDisplayName: '包装显示名',
  ChargeSource: '数据来源',
  AddressOfContact: '联系人地址',
  FinancialExamineDate: '财务审核日期',
  ReceiptStatus: '回执状态',
  TransitInformation: '中转信息',
  ThreeWay: '三程',
  placeOrder: '下单',
  BatchUpdateCustomJobType: '批量修改自定义业务类型',
  CustomJobTypeBatchModifySuccess: '批量修改自定义业务类型成功:',
  BatchManagerSubmission: '批量主管提交',
  BatchManagerSubmissionTips: '主管只能批量提交正操作和预提交的业务！',
  BatchManagerSubmissionSuccessfully: '批量主管提交成功：',
  VotesManagerSubmission: '票进行主管提交吗？',
  CopyEnglishDescriptionOfGoodsFromMergeJob: '取加入并单的英文品名',
  CopyMarkFromMergeJob: '取加入并单的唛头',
  SyncToSmallTicket: '同步至小票',
  externalBusinessStatus: '订单状态', // 爱拼订单状态
  SoNo1: 'S/O No.',
  NaturalPerson: '自然人',
  LegalPerson: '法人',
  IndividualAssociation: '个人协会',
  TelSeparate: '区号请用"-"隔开',
  EnsNo: 'ENS 号码',
  ShippingCompanyEORI: '船公司EORI',
  DeclarantEORI: '申报人EORI',
  Memberstate: '进入欧盟的第一个国家',
  ENSNumber: 'ENS号码',
  EnsHsCodeNotMatch: '货物信息序号跟箱子信息不匹配',
  EnsCorrelativeNoRepeat: '货物信息序号有重复',
  LinkedCargoInformationNoNotNull: '装箱信息关联货物信息序号不能为空',
  maxLength: '长度不能超过{0}个字符',
  PleaseEnterLength: '请输入{0}个字符',
  FreightTermConflict: '的选择与卸货港交货地信息选择有冲突',
  FreightTermConflict2: '的选择与装货港收货地信息选择有冲突',
  NeedPrefix: '需要带前缀申报，单号前缀：{0}',
  RemoveThePrefix: '需要去掉前缀：{0}',
  PhoneTooLong: '区号不能大于4个字符，电话不能大于20个字符',
  SaveOnly: '仅保存',
  Only6: '仅支持6位数字',
  ChargesPaymentMethod: '费用支付方式',
  CopyConsignor: '复制发货人',
  CopConsignee: '复制收货人',
  BuyerAndSellerInformation: '买卖方信息',
  StreetNumber: '街道号码',
  WaitingForReceipt: '上次发送成功且暂未收到回执，请等待回执后再次发送',
  DirectlyRepresenting: '直接代表',
  IndirectRepresentation: '间接代表',
  NeedOne: '只需添加一条数据',
  ContainShutOutJob: '包含退关业务',
  BatchEditJobNo: '批量修改业务编号',
  IncludingSCFIFreightRate: '包含SCFI运价',
  SCFIDesignatedBoxType: 'SCFI指定箱型',
  JingyiSystemForecast: '荆艺系统预报',
  OriginalAHR: '原始AHR',
  AddChr: '增加CHR',
  CorrectAFR: '更正AFR',
  NonRepeatingNumbers: '请输入不重复的数字',
  AddressFormatting: '地址格式化',
  SendToGoFreight: '发送至GO FREIGHT',
  ViewSendLog: '查看发送日志',
  BookingFreightRate: '订舱运价',
  SelectedDataDeclaration: '选中数据申报',
  EmptySubmissionDeclaration: '空提交申报',
  SettlementFreightRate: '结算运价',
  DeclarationRecord: '申报记录',
  ImNotHavePermissionDetails: '对不起!您没有权限查看详细信息.',
  ActionOptionsNotCaptured: '未捕获到操作选项!',
  BatchNotSupportedPleaseAgain: '不支持批量发送，请重新选择！',
  ItFreightAndRepeatedAllowed: '已经发送至GO FREIGHT，不允许重复发送',
  SentSuccessfully: '发送成功',
  CheckTheSendingLog: '是否查看发送日志',
  OnlyToViewTheSelect: '只能选择一个业务进行查看发送日志，请重新选择！',
  ItUpTo50Businesses: '最多可处理50条业务.',
  Business: '业务:',
  NonIntegralType: '非整拼类型',
  SendComplete: '发送完成',
  PackingList: '安箱单',
  PleaseContainerBusinessForOperation: '请选择整箱业务进行操作！',
  EmptyInterfaceSendingPleaseWait: '提空箱数据接口发送中,请稍等......',
  VerificationOfDeclarationData: '申报数据校验',
  DataCheckTheDataAgain: '数据验证失败，请核对数据后再试。',
  PleaseWhetherToSubmitThis: '请确认是否提交这',
  TicketData: '票数据？',
  DataDeclarationSucceeded: '数据申报成功.',
  EmptySubmittedSuccessfully: '空提交成功.',
  NotData: '没有数据.',
  ThereElectronicPackingListData: '没有电子箱单数据.',
  SendFailed: '发送失败:',
  Empty: '为空',
  PleaseOfDepartureMustPort: '请确认起运港必须为上海港。',
  PleaseMustBeTheExchange: '请确认卸货港必须为航交所指定港。',
  PleaseOfGoodsMustGoods: '请确认货物类型必须为普货。',
  PleaseOfTheMainCY: '请确认主单运输条款必须为“CY-CY”。',
  PleaseTradeTermsMustCIF: '请确认贸易条款必须为“CIF”。',
  PleaseBoxQuantityInformationCorrect: '请确认箱量信息是否正确。',
  TheAmountReceivableIncludesUSD: '请确认费用-应收包含指定USD款项。',
  NoBillOfLadingInformation: '没有HBL提单信息.',
  ResponseDataIsEmpty: '响应数据为空',
  PleaseToViewTheLog: '请选择要查看发送日志的业务！',
  ExportEDI: '是否导出EDI？',
  LandTransportationDetailsEditing: '陆运详细信息编辑',
  PreviewOfBookingFileParsing: '订舱文件解析预览',
  GenerateOrder: '生成订单',
  HangInTheAir: '未完成',
  Completed: '已完成',
  Dustbin: '垃圾箱',
  PictureLoadingFailed: '图片加载失败',
  ResolutionCompletionTime: '解析完成时间',
  ViewParsingResults: '查看解析结果',
  ViewOrder: '查看订单',
  AreYouWantToDelete: '确认要删除吗？',
  BusinessNumber: '业务号',
  LCL: '整箱拼箱',
  NearlyAWeek: '近一周',
  NearlyAMonth: '近一个月',
  NearlyThreeMonths: '近三个月',
  DragUploadTheFileIdentified: '拖拽文件至此处上传需要识别的文件',
  SupportUploadFormat: '支持上传的格式',
  ParsingFailed: '解析失败',
  ParsingComplete: '解析完成',
  OrderGenerated: '已生成订单',
  UploadCompletedParsing: '上传完成，正在解析...',
  Second: '秒',
  ReviewRejectedBusinessNumber: '复核拒绝的业务编号',
  RejectedBusinessNumber: '已拒绝的业务编号',
  TheNotExceed5Lines: '最大不能超过5行！',
  Interface: '接口',
  Sinotrans: '中外运',
  SinotransEastChinaCoLtd: '中国外运华东有限公司',
  NingboEPort: '宁波电子口岸',
  SeaHousekeeper: '海管家',
  Wse: '未斯',
  CargoWare: 'Cargoware发送',
  EDISend: 'EDI发送',
  OtherChannel: '其他通道',
  Ningbo99Road: '宁波99路',
  DeclarationHistory: '申报历史',
  CredentialNumber: '凭据编号',
  ResponseCode: '响应码',
  ElectronicBoxListSendingHistory: '电子箱单发送历史记录',
  PrintTime: '打印时间',
  PrintingTimes: '打印次数',
  BookingDataFeedback: '订舱数据反馈',
  QuerySendingLog: '查询发送日志',
  SendDataInformation: '发送数据信息',
  ExportAllEDI: '导出全部EDI',
  UploadThisPageEDI: '上传本页EDI',
  UploadAllEDI: '上传所有EDI',
  EmailUploadEDI: '邮件上传EDI',
  IsExportEDI: '是否导出EDI?',
  UploadEDI: '是否上传EDI?',
  IsUploadAllEDI: '是否上传所有的EDI?',
  MailSending: '邮件发送',
  UploadEDISucceeded: '上传EDI成功',
  FailedToUploadEDI: '上传EDI失败',
  CurrentNetworkChannelUnstable: '由于通道当前网络不稳定，是否转入后台发送列队?',
  EdiTips: 'EDI发送提示',
  HasBillExist: '【{0}】已有提单号在系统发送队列中。请耐心等待，无需重复发送。',
  MultiSegmentNumberRuleConfiguration: '多段号码规则配置',
  StartNumber: '起始号码',
  IncrementalRule: '递增规则',
  DirectExport: '直接导出',
  Plus1: '加1',
  Plus10: '加10',
  TheNumberCannotBeEmpty: '起始号码不能为空.',
  IllegalNumberEntry: '号码录入不合法.',
  TheMustBeGreaterZero: '份数必须大于零.',
  IncrementRuleIsNotSelected: '递增规则未选择.',
  PleaseBusinessNumberSearchCriteria: '请输入业务编号搜索条件',
  UploadCompletedProcessing: '上传完成，处理中',
  SuccessfulProcessing: '处理成功',
  ProcessingFailed: '处理失败',
  ExportTime: '导出时间',
  UnitPriceCannotBe0: '单价不能为0',
  ExchangeRateCannotBe0: '汇率不能为0',
  CustomsNoCannotBeBlank: '关单号不能为空!',
  ShipperCityCannotBeBlank: '请输入发货人城市名称',
  PrimaryCustomsNo: '是否主关单号',
  GetPackingInformation: '获取装箱信息',
  GetGoodsInformation: '获取货物信息',
  GetGoodsInformationTip: '获取[货物信息]页签关联的进仓记录的尺寸',
  SynchronizeMainTicketPackingInformation: '同步主票装箱信息',
  CaseNumberCannotBeEmpty: '箱号不能为空.',
  InvalidCaseNumber: '无效的箱号.',
  TheSealNumberCannotBeEmpty: '封号不能为空.',
  BoxTypeCannotBeEmpty: '箱型不能为空.',
  EnglishNameCannotBeEmpty: '英文品名不能为空.',
  TheMarkCannotBeEmpty: '唛头不能为空.',
  HscodeCannotBeEmpty: 'HSCODE不能为空.',
  EqCodeMatchError: '箱型箱种未匹配，请重新选择',
  ThePackageCannotBeEmpty: '包装不能为空.',
  ThePiecesCannotBeEmpty: '件数不能为空.',
  GrossWeightCannotBeEmpty: '毛重不能为空.',
  VolumeCannotBeEmpty: '体积不能为空.',
  DanUNNoCannotBeEmpty: '【UN Code】危险品必填，范围0001-9999',
  DanClassNoCannotBeEmpty: '【危险品等级】危险品必填，范围：1-9.9',
  DangerousGoodsContactCannotBeEmpty: '危险品联系人不能为空.',
  DangerousGoodsContactPhoneNumberCannotBeEmpty: '危险品联系人电话不能为空',
  TherePleaseEnterItTab: '没有可导入的信息, 请到“装箱信息”页签录入',
  NoMasterTicketInformationYet: '暂无主票信息！',
  WeighingMethod: '称重方式',
  VGMLLC: 'VGM责任公司',
  VGMWeightAddress: 'VGM称重地址',
  VGMSignature: 'VGM签名',
  TareWeight: '箱皮重',
  TareWeightUnit: '箱皮重单位',
  WeighingAddress: '称重地址',
  WeighingMethodCannotBeEmpty: '称重方式不能为空.',
  TheWeightCannotBeEmpty: '总重不能为空.',
  VGMCompanyCannotBeEmpty: 'VGM责任公司不能为空.',
  VGMSignatureCannotBeEmpty: 'VGM签名不能为空.',
  MailboxCannotBeEmpty: '邮箱不能为空.',
  PhoneNumberCannotBeEmpty: '电话不能为空.',
  WeighingAddressCannotBeEmpty: '称重地址不能为空.',
  NotifierCodeCannotBeEmpty: '通知人企业代码不能为空.',
  ContactNotifierCannotBeBlank: '通知人联系方式不能为空.',
  ImportTallyInformation: '导入理货信息',
  PTImport: 'PT导入',
  SelectTime: '选择时间',
  CaseNoSealNo: '箱号-封号',
  CopySmallTicketCost: '抄录小票成本',
  PleaseCostToBeCopied: '请选择要抄录的成本费用.',
  CrossTenantDelegationHistory: '跨tenant委托历史状态记录',
  Operator: '作业人',
  OperationTime: '作业时间',
  DelegationStatusHistory: '委托状态历史记录',
  GeneratePrimaryDocNo: '生成主单号',
  PleasePrimaryOrderNumberRule: '请选择主单号规则',
  PleaseCodeOfTheNo: '请选择主单号的服务码',
  SendOnlineManifestInvitationEmail: '在线舱单邀请邮件发送',
  PleaseConfirmEmailAddress: '请确认邮箱地址：',
  ShippingPreConfigurationInformationManifest: '海运订舱极速版-预配信息-邀请在线舱单',
  TheSentToTheIt: '邀请链接已发送至邮箱，请注意查收！',
  TotalCustomsNo: '关单号合计',
  TotalNumberOfPieces: '件数合计',
  TotalGrossWeight: '毛重合计',
  TotalVolume: '体积合计',
  CustomsNoNotImported: '未导入关单号:',
  ImportDate: '导入日期',
  ImportUser: '导入用户',
  SendUser: '发送用户',
  ManifestImportUser: '舱单导入用户',
  SendTag: '发送标记',
  SubtotalOfCustomsOrderNo: '关单号小计',
  ConfirmToVoid: '是否确认作废？',
  MBNOCannotBeEmpty: 'MB/L No不能为空!',
  ShipNameCannotBeEmpty: '船名不能为空!',
  VoyageCannotBeEmpty: '航次不能为空!',
  ShippingCompanyCannotBeEmpty: '船公司不能为空!',
  ShippingAgentCannotBeEmpty: '船代不能为空!',
  DestinationPortCannotBeEmpty: '目的港不能为空!',
  GoodsTypeCannotBeEmpty: '货物类型不能为空!',
  TransportationTermsCannotBeBlank: '运输条款不能为空!',
  FreightTermsCannotBeBlank: '运费条款不能为空!',
  BillTypeCannotBeEmpty: '提单类型不能为空!',
  PaymentPlaceCannotBeEmpty: '付款地点不能为空!',
  MattersNeedingAttention: '注意事项',
  DontRemindMeAgain: '下次不再提醒',
  CloseSpace: '关 闭',
  TheBeenSentToSending: '该舱单中关单号【{0}】已发送过EDI，是否继续发送？',
  SelectToSendPreManifest: '选择发送预配舱单通道',
  SelectCorrectConfiguredManifestChannel: '选择更正预配舱单通道',
  SelectDeleteConfiguredManifestChannel: '选择删除预配舱单通道',
  ThePleaseRefreshTheAgain: '清洁舱单对象为空,请刷新页面后重试',
  CustomsClearanceNo: '分关单号',
  ShippingCompanyOperation: '船公司操作',
  CustomsRestAssured: '海关放心',
  PlanType: '计划类型',
  AcceptanceTime: '受理时间',
  ScheduledStartTime: '计划开始时间',
  PlannedEndTime: '计划结束时间',
  DepartureTime2: '开港时间：',
  PortCutOffTime: '截港时间：',
  ActualBerthingTimeColon: '实际靠泊时间：',
  ActualDepartureTimeColon: '实际离泊时间：',
  ClickToViewTheTrailer: '点击查看拖车',
  DisplayPortArea: '以下数据显示的是港区/船公司数据',
  DetailedData: '详细数据',
  manualPrompt: '橙色数据：数据服务',
  thirdPartyPrompt: '浅蓝数据：手动输入',
  promptNo: '灰色数据：暂无数据',
  promptNoData: '暂无数据',
  ArrivalReportStatus: '运抵报告状态',
  CustomsClearanceSheetStatus: '分关单状态',
  PlanDetails: '计划详情',
  PutInTheBox: '已放箱',
  EmptyBox: '提空箱',
  Arrival: '进港',
  EstimatedCYOpening: '预计开港',
  PortDocCutOff: '港区截单',
  ActualBerthing: '实际靠泊',
  ActualDeparture: '实际开船',
  customsClearance: '海关放行',
  DockRelease: '码头放行',
  CancelCustomsClearance: '取消海放',
  CancelDockRelease: '取消码放',
  AllocateVehiclesToTransportSth: '配载',
  Sail: '开航',
  Departure: '离港',
  Pickup: '提重',
  BusinessFunction: '业务功能',
  ClickTheButton: '点击按钮',
  ReturnAddress: '还箱地址',
  DepartureTime3: '离港时间',
  ArrivalWharf: '到港码头',
  departureTime: '出港时间',
  StowageTime: '配载时间',
  AbnormalCause: '异常原因',
  StackingTime: '码放时间',
  StackingState: '码放状态',
  SeaReleaseTime: '海放时间',
  SeaReleaseDescription: '海放说明',
  SeaReleaseState: '海放状态',
  arrivalTime: '进港时间',
  TrailerFollow: '拖车跟着',
  SuitcaseLocation: '提箱地点',
  BoxReleaseTime: '放箱时间',
  EstimatedPickUpPoint: '预计提箱点',
  Wharf: '码头',
  NameNumberOfImportedVessels: '进口船名船次',
  FieldBoxPosition: '场箱位',
  NameNumberOfExportVessel: '出口船名船次',
  containerWeight: '箱货重',
  VGMWharfWeighing: 'VGM码头称重',
  ContainerHolder: '持箱人（仅提供上海港口）',
  LeadSeal: '铅封号',
  TransshipmentPort: '转运港',
  VGMMessageReceiving: 'VGM报文接收',
  ApproachMode: '进场方式',
  ArrivalMessageTime: '运抵报文时间',
  AppearanceMode: '出场方式',
  ReeferTemperatureRequired: '冷藏温度',
  ReceivedTheReleaseTime: '收到海放时间',
  NationalInspectionRelease: '国检放行',
  OverrunCode: '超限代码',
  WharfStowage: '码头配载',
  EmptyContainerRelease: '空箱放行',
  Front: '前',
  After: '后',
  SuperLong: '超长',
  FlowTo: '流向',
  Left: '左',
  Right: '右',
  UltraWide: '超宽',
  MaritimeReleaseException: '海事放行异常',
  SuperHigh: '超高',
  QuantityOfBoxesAndPieces: '箱量件数:',
  GreaterActualNumberOfPieces: '大于实际件数:',
  BoxWeight: '箱量重量:',
  GreaterThanActualWeight: '大于实际重量:',
  BoxVolume: '箱量体积:',
  LargerThanActualVolume: '大于实际体积:',
  JobNoColon: '工作号:',
  AddSpellCustomsOrderNo: '加拼关单号',
  PleaseForAddingAndForm: '请选择加拼关单号的规则',
  PleaseSelectSuffixSeparator: '请选择后缀分隔符',
  PleaseCustomsDeclarationNoSpelled: '请输入需要加拼的关单号数量',
  DirectToCanada: '直达加拿大',
  ToInlandWarehouse: '到内陆仓库',
  TransitClearancePullToStates: '在加拿大中转，不清关，拉到美国',
  TheThroughTheUnitedStates: '货物途径美国',
  PleaseSelectAnAccount: '请选择账户',
  PleaseOfYourCurrentFirst: '请先维护您当前所在部门的代码！',
  ItServiceProviderOfHouse: '已成为"沃行之家"服务商',
  YouHisPartnerAndService: '您可以在线申请成为他的合作伙伴，即可享受在线下单服务。',
  PleaseSelectTheEntrustingCompany: '请选择委托单位!',
  PleaseSelectDestinationAgent: '请选择目的港代理!',
  UncheckedSmallTicket: '未勾选小票',
  CustomerInformation: '客户信息',
  CodeCannotBeEmpty: '代码不能为空.',
  TheNameCannotBeEmpty: '名称不能为空.',
  CertificateTypeCannotBeBlank: '证件类型不能为空.',
  IDNumberCannotBeEmpty: '证件号码不能为空.',
  AddressCannotBeEmpty: '地址不能为空.',
  CityCannotBeEmpty: '城市不能为空.',
  CountryCannotBeEmpty: '国家不能为空.',
  ThisSuccessfullyInsuredRepeatedAllowed: '此票业务已投保成功，不允许重复投保',
  Seller: '卖家',
  Manufacturer: '制作商',
  Consolidator: '集运商',
  OriginalBookingParty: '原始订舱方',
  GoodsReceiver: '货物接收方',
  PackingPoint: '装箱点',
  Importer: '进口商',
  AMSNoCannotBeBlank: 'AMS分单号不能为空.',
  SCACCompanyCannotBeEmpty: '船公司SCAC不能为空.',
  TheDischargeCannotBeEmpty: '卸货港不能为空.',
  TheDeliveryCountryCannotBeEmpty: '交货地国家不能为空.',
  TheDeliveryCannotBeEmpty: '交货地不能为空.',
  CorrectionOfBillOfLading: '更正提单',
  OriginalBillOfLading: '原始提单',
  TheBillOfLadingEmpty: '提单发货地不能为空',
  SailingDateEmpty: '开航日期不能为空',
  TransceiverSelection: '收发通选择',
  YouServiceOfTheManifest: '预配舱单问题可点击图标，咨询海管家客服。',
  OriginalCleaningManifest: '原始清洁舱单',
  Correction1: '更正1',
  CorrectCleaningManifest: '更正清洁舱单',
  SendPreConfiguredManifest: '发送预配舱单',
  CorrectionOfPreAllocationManifest: '更正预配舱单',
  DeletePreConfiguredManifest: '删除预配舱单',
  CancelPreConfiguredManifest: '撤销预配舱单',
  OriginalPreAllocatedManifest: '原始预配舱单',
  CleanManifestAPI: '清洁舱单API',
  OriginalVGM: '原始VGM',
  HscodeConfigurationInformationCannotEmpty: '预配信息的HSCODE不能为空.',
  HscodeInformationMustBeDigits: '预配信息的HSCODE必须是6位.',
  PleaseTickTheBoxForTheCargoInformationYouWantToAmendTheManifest: '请勾选您要修改舱单的货物信息',
  PleaseConfirmThatTheCustomsInformationYouSelectedHasNotBeenModified: '您选择的关单信息并未修改，请确认',
  PleaseSelectAllSeaHouseUpdateData: '您修改【舱单基本信息】&【客户发运信息】模块内容，需要选中全部发送过的关单信息一起发送',
  SendingSucceeded: '发送成功！',
  TheTheReceiptLogInformation: '原始舱单已发送，点击回执日志查看舱单回执信息。',
  UpdateSucceeded: '更新成功！',
  PleaseSuccessfullyIfNotFirst: '请确认原始舱单是否发送成功，如未发送，请先发送原始舱单。',
  DeleteSucceeded: '删除成功！',
  WseModifyReasonNotEmpty: '请选择改单原因',
  WseModifyRemarkNotEmpty: '请补充改单说明',
  WseDeleteReasonNotEmpty: '请选择删单原因',
  WseDeleteRemarkNotEmpty: '请补充删单说明',
  BrandNew: '全新',
  SecondHand: '二手',
  Unknown: '不详',
  ReImportAfterModification: '可修改后重新导入',
  FailedToDownloadData: '下载失败数据',
  ClickVehiclePositioningAndTrack: '点击按钮查询车辆定位和车辆行驶轨迹。',
  VehiclePositioningTrack: '车辆定位轨迹',
  IfToTheCurrentIt: '当前运输公司的应付费用状态已变更，（删除/编辑）后将不再同步到费用页签，是否继续？',
  VehicleTrajectory: '车辆行驶轨迹',
  DistributionCustomsNo: '分配关单号',
  BookingReceipt: '订舱回执',
  InMailOfThePrevail: '内测阶段，以船东邮件为准',
  CorrectBooking: '更正订舱',
  OriginalBooking: '原始订舱',
  TheBeVoidedAndThis: '主单号已生成，再次生成会作废原单号并生成新单号，是否确认要这么做？',
  BasicTab: '基本页签',
  TheHairBodyCannotEmpty: '实际件毛体不能为空',
  PackageCannotBeEmpty: '包装不能为空',
  MBLTab: 'MBL页签',
  ShipperCannotBeBlank: '发货人不能为空',
  ConsigneeCannotBeEmpty: '收货人不能为空',
  NotifierCannotBeBlank: '通知人不能为空',
  TheEmptyPleaseRefreshAgain: '预配舱单对象为空,请刷新页面后重试',
  TheIsEmptyPleaseAgain: '预配舱单更正对象为空,请刷新页面后重试',
  VGMRefreshThePageAgain: 'VGM对象为空,请刷新页面后重试',
  TheCleaningIsEmptyPleaseAgain: '预配清洁舱单对象为空,请刷新页面后重试',
  TheNoCannotBeBlank: '关单号不能为空.',
  MBLNoCannotEmpty: 'MB/L NO不能为空.',
  NewGoods: '新增货物',
  DeleteGoods: '删除货物',
  TotalOfThisBox: '本箱子合计：',
  DataComparison: '数据对比',
  UpdatePortAreaData: '更新港区数据',
  NoPortDataHasBeenObtained: '暂未获取到港区数据',
  SynchronizePortData: '同步港区数据',
  NotVerified: '未校验',
  SystemVerification: '系统校验一致',
  ManualVerification: '手动校验一致',
  ToBeConfirmed2: '待确认',
  TheInThePortOpened: '尚未开通港区箱货数据推送服务',
  TheDirectlyImportTheCall: '港区箱货数据服务可帮助您校验箱货信息是否正确，亦可直接将港区箱货数据导入业务。如需开通请联系在线客服或拨打联系电话：',
  HarbourNotInServiceNoOpen: '对应港口暂未开通数据对比服务，无法提供数据对比功能。目前支持其他港口进行数据对比，如需开通请联系在线客服或拨打联系电话：',
  HarbourInServiceNoOpen: '港区箱货数据服务可帮助您校验箱货信息是否正确，亦可直接将港区箱货数据导入，实现轻松录入数据。如需开通请联系在线客服或拨打联系电话：',
  HarbourNotInServiceOpen: '当前不支持该港区数据的推送及对比。',
  ThisActionCannotBeUndone: '此操作不可撤销',
  DoYouWantToContinue: '您还要继续吗?',
  ItPortDataAndVerified: '与港区数据不匹配，无法校验',
  TheNotContainTheData: '当前数据不包含以下港区数据',
  PortInformationVerification: '港口信息校验',
  SIsMissingAndVerified: 'S/O NO缺失，无法校验',
  PleaseNoForTheFirst: '请先为当前小票填写S/O NO',
  TheOverwriteTheCurrentData: '功能会覆盖当前数据',
  OperationSucceeded: '操作成功！',
  OrderNumber: '订单数',
  TotalPacking: '总包装数',
  ContainerList: '集装箱列表',
  UpdateStatus: '更新状态',
  ClearThePackingInformation: '清除装箱信息',
  ExportThePackingPlan: '导出装箱计划',
  checkGoods: '查看商品',
  checkPackages: '查看包装',
  NumberOfPackages: '包装数量',
  AskForPositionTime: '要求进仓时间',
  EstimatedPositionTime: '预计进仓时间',
  CheckTheDetailsOfTheGoods: '查看货物详情',
  UnableToRemove: '无法移除，集装箱已锁定或已装箱',
  removeOrderTips: '是否确定移除此订单？',
  removeOrder: '移除订单',
  PackageNo: '包装号',
  NumberOfPackagesAnticipateOrReality: '包装数(预/实)',
  Code4: '编码',
  LengthAnticipateOrReality: '长(预/实)',
  WidthAnticipateOrReality: '宽(预/实)',
  HighAnticipateOrReality: '高(预/实)',
  UnitVolumeAnticipateOrReality: '单位体积(预/实)',
  GrossWeightAnticipateOrReality: '单件毛重(预/实)',
  Considerations: '注意事项',
  Anufacturer: '生产商',
  EstimateLoadingTime: '预计货好时间',
  ActualWarehousingTime: '实际进仓时间',
  NO: '号',
  NoCorrespondingFile: '没有取到对应的文件！',
  ChooseState: '选择状态',
  ActualPackingTime: '实际装箱时间',
  ChooseActualPackingTime: '请选择实际装箱时间',
  updateContainerStateTip: '更新失败，该箱子存在未入仓的订单',
  firstCleanedContainer: '请先选择需要清除的集装箱',
  containerBeCleared: '的集装箱无法清除',
  removeSelectedContainer: '是否确定移除所选集装箱下的全部订单？',
  ClearContainerInformation: '清除集装箱信息',
  goodsOperateTips: '请先保存该单号信息，再进行货物操作',
  removeGoodsTips: '请选择要移除的货物',
  NumberOfCartons: '纸箱数',
  importGoodsTips: '请选择要导入的货物',
  ChooseGoods: '选择货物',
  RemoveTheGoods: '移除订单',
  Source: '来源',
  PreCommitUser: '预提交人',
  PreCommitDate: '预提交时间',
  SubmissionDate: '提交时间',
  CommitUser: '提交人',
  RelatedSubmissionDate: '往来关联业务提交时间',
  RelatedCommitUser: '往来关联业务提交人',
  RelatedPreCommitUser: '往来关联业务预提交人',
  RelatedPreCommitDate: '往来关联业务预提交时间',
  FcAuditDate: '审核时间',
  FcAuditUser: '审核人',
  LockJobDate: '锁单时间',
  LockJobUser: '锁单人',
  PrintListTip: '请选择一个您要打印的单子',
  CargoActArrivalDatePacking: '实际装箱日期',
  releaseStowageState: '放行配载状态',
  ChangeHistory: '变更历史记录',
  SynchronizationInformation: '同步信息',
  SyncChargeToEas: 'EAS同步',
  NoEasCharge: '没有需要同步到EAS的费用。',
  CheckEasChargeState: '没有需要同步到EAS的费用，请检查EAS费用状态。',
  CheckBusinessUuid: '业务UUID不能为空！',
  KingDeeChargePush: '金蝶费用推送',
  ExternalSerialNumber: '单据号',
  EmptyCabinetDate: '空柜进厂时间',
  RealArrivalsDate: '实际进港时间',
  ActualLiftingDate: '实际提重时间',
  DeliveryDoneDate: '送货完成时间',
  CleaningDate: '清柜时间',
  ReturnBoxDate: '还箱时间',
  DestinationDeliveryTime: '目的港送仓时间',
  DestinationReturnTime: '目的港还空时间',
  PortDischargeTime: '实际卸船时间',
  EstimatedPortDischargeTime: '预计卸船时间',
  UnloadingTime: '卸船时间',
  LiftingTime: '提重时间',
  RailwayDepartureTime: '实际铁路运输时间',
  EstimatedRailwayDepartureTime: '预计铁路运输时间',
  RailwayDischargeTime: '实际铁路卸货时间',
  EstimatedRailwayDischargeTime: '预计铁路卸货时间',
  EstimatedTimeOfArrivalAtThePlaceOfDelivery: '预计抵达交货地时间',
  Arrived: '抵达',
  Acquire: '收单',
  TheActualTimeOfArrivalAtThePlaceOfDelivery: '实际抵达交货地时间',
  EstimatedCustomsReleaseTime: '预计放关时间',
  EstimatedPickupTime: '预计提重时间',
  ActualPickUpTime: '实际提重时间',
  EstimatedDeliveryToWarehouseTime: '预计进仓交货时间',
  EstimatedReturnTime: '预计还空时间',
  ActualReturnTime: '实际还空时间',
  PODDeliveryInformation: '目的港派送信息',
  ActualDeliveryToWarehouseTime: '实际进仓交货时间',
  EstimatedDeliveryToCustomersWarehouseTime: '预计送货时间',
  ActualDeliveryToCustomersWarehouseTime: '实际送货时间',
  PickupMessage: 'CY-DOOR，从港区到整箱仓库/拼箱的拆箱仓库',
  DeliveryToWarehouseMessage: '提重后送进目的港仓库的时间',
  EstimatedDeliveryToCustomersWarehouseMessage: '从拼箱仓库到客户仓库（B2B)/从发货仓最后一公里派送(B2C）',
  ActualDeliveryToCustomersWarehouseMessage: '从拼箱仓库到客户仓库/从发货仓最后一公里派送',
  CargoReadyDate: '货好时间',
  BackUpWarehouse: '前置仓',
  PleaseSelectBackUpWarehouse: '请勾选【前置仓】选项',
  HeavyContainerMobilization: '重箱进场',
  checkLines100: '选中行数不能超过100行！',
  estimatedDeliveryTime: '预计出仓时间',
  estimatedArrivalTime: '预计进港时间',
  EmailGroup: '邮件群组',
  EmailTemplate: '邮件模板',
  CargoAllocationList: '配舱清单',
  CheckApproved: '请勾选要审核的业务！',
  StateVerifyingReview: '已审核（待复核）',
  VotesSubmission: '票进行提交吗?',
  BatchSubmitCheckOperate: '只能批量提交正操作的单子!',
  BatchSubmitCheckPre: '只能批量提交预提交的单子!',
  CancelFormalHblTips: '已经存在形式分单，请移除后再取消勾选！',
  BatchSend: '批量发送',
  BatchSendCheck: '请勾选需要发送的EAS费用',
  BatchSendTip: '只能同步未审核的费用，请检查费用状态',
  PleaseSelectRemovedContainer: '请选择需要移除的装箱信息！',
  PleaseRemovedSplitOrder: '请先移除关联当前拆单的形式分单!',
  ThereAreTheFollowingExceptionsInTheImportDataPleaseCheckTheDataInTheForm: '导入数据存在以下异常，请在表单中核对数据',
  NoPrimaryTicketIsAssociatedSoTheContainerDataCannotBeImported: '未关联主票，无法导入箱货数据',
  ImportContainerInformation: '是否导入箱货信息?',
  SecondLoadingTime: '中转装船',
  SecondDepartureTime: '中转开航',
  SecondArrivalTime: '中转抵港',
  SecondUnloadingTime: '中转卸船',
  TransferModeAtTransferPoint: '中转点转运方式',
  DispatchVehiclesAtDestination: '目的港派车',
  PortOfDestinationServices: '目的港服务',
  Manifest: '预配舱单',
  Other: '其他',
  Temperature: '温度',
  OpenVentilation: '开启通风',
  VentilationQuantity: '通风量',
  VentilationUnit: '通风量单位',
  FlashPointUnit: 'Flashpoint 单位',
  HazardForm: '危险品形态',
  AutoSpecialGoods: '自动获取特殊货物的装箱信息',
  HaveMaintainedSpecialInfo: '检测到您已维护了特殊货物信息，是否根据英文品名和HS编码自动获取装箱信息？',
  PackingInformation: '成功获取装箱信息。',
  NoPackingInformation: '未获取到装箱信息。',
  Humidity: '湿度%',
  OverSize: '超尺寸',
  ZYQHG: '左/右/前/后/高超(CM)',
  PortOfDestinationCustomsClearance: '目的港清关',
  PortOfDestinationCustomsData: '目的港清关数据',
  ProductName: '品名',
  DeleteThisProduct: '删除本条品名',
  CustomsTariff: '清关关税',
  AddMultipleProductArea: '新增多品名区域',
  PleaseSelectData: '请选择指定数据',
  PlateNumberAndBillLadingNumberCannotEmpty: '车牌号和提单号不能为空',
  LineXQuantityMustGreaterThanZero: '第{rowNum}行件数必须大于0',
  LineXQuantityExceedsMaxValue: '第{rowNum}行件数{quantity}超出最大值{maxValue}',
  LineXWeightMustGreaterThanZero: '第{rowNum}行毛重必须大于0',
  LineXWeightExceedsMaxValue: '第{rowNum}行毛重{weight}超出最大值{maxValue}',
  LineXCubageMustGreaterThanZero: '第{rowNum}行体积必须大于0',
  LineXCubageExceedsMaxValue: '第{rowNum}行体积{cubage}超出最大值{maxValue}',
  HasExport: '已导出',
  DelegatedAssociatedBusinessStatus: '委托关联业务状态',
  TransactionRelatedBusinessStatus: '往来关联业务状态',
  SecondarySynchronization: '二次同步',
  NumberOfCustomsOrders: '关单数',
  CustomerClosingTime: '客户截单时间',
  AddToMainTicket: '是否加入主票',
  CustomsDeclarationRemark: '报关备注',
  OperationGuide: '操作指南',
  ServiceInformation: '服务指南',
  ScopeServices: '服务范围',
  DeletionGuide: '上海港删改指南',
  BusinessData: '上海港业务资料',
  SecondVesselInformation: '二程信息',
  vesselText: '通过港区箱货数据获取到到船名：${1}、航次：${2} 与订舱页签船名：${3}、航次：${4} 不一致，是否写入提单获取的船名航次，并清空已获取的船期数据？',
  textiles: '纺织品',
  nonTextiles: '非纺',
  importEmpty: '导入并清空',
  importNotEmpty: '导入不清空',
  ignore: '忽略',
  empty: '空',
  salveNoDcToKeepMaster: '该委托单位未维护相应单证人员，是否保留主票单证人员？',
  CustomersCollectByBubble: '客户分泡收取',
  CollectionBySupplier: '供应商分泡收取',
  Slac: '货物小件数',
  BookingShutOut: '订舱退关',
  tip: '提示',
  ShippingCompanyDialogModifyText: '您修改了船公司，是否清空已有的目的港港区信息？如您开通船公司货物追踪服务，将会重新订阅订舱页签目的港港区信息。',
  ShippingCompanyDialogDeleteText: '您删除了船公司，是否清空已有目的港港区信息？',
  emptyDestinationInformation: '清空',
  noEmptyDestinationInformation: '不清空',
  BatchModifyBusiness: '批量修改业务',
  DataAdjustment: '数据调整',
  OriginalData: '原数据:',
  AfterAdjustment: '调整后:',
  inputContainerNo: '请填写箱号',
  inputSealNo: '请填写封号',
  BoxType: '箱型箱种',
  BusinessPeopleType: '业务人员',
  clearConfirm: '已勾选业务【{0}】【{1}】数据将被清除，是否确认？',
  clearCategoryConfirm: '已勾选业务【{0}】数据将被清除，是否确认？',
  changeTwoConfirm: '已勾选业务【{0}】【{1}】数据将被替换，是否确认？',
  changeOneConfirm: '已勾选业务【{0}】数据将被替换，是否确认？',
  hasRefreshCharge: '订舱代理已经存在费用,是否刷新费用？',
  SuccessTip: '成功{0}条',
  successTipAlreadyNotEditCharge: '成功{0}条，<br/>说明: <br/> {1} 已经存在不可编辑费用，请及时处理!',
  hasOneAtleast: '请至少选择一个选项后再试！',
  hasOneNoAtleast: '请至少填写一个栏位后再试！',
  maxSelectBusiness: '勾选的业务超过{0}条，请重新选择后再试！',
  requireAllSelect: '请选择修改后的{0}和{1}后再试',
  hasOneCategoryAtleast: '请选择您需要写入的数据！',
  adjustedDestinationAgent: '请输入调整后的目的港代理!',
  whetherCoverMBLReceiver: '已勾选业务目的港代理数据将被替换，是否需要根据目的港代理信息要盖MBL收货人信息?',
  lclSlavesJobCannotModify: '小票不能修改该字段！',
  BusinessNotSameOpAndSalesOffice: '业务{0}操作分公司与销售分公司不一致',
  SuccessfullyClearXPieces: '成功清除{0}条{1}数据',
  PartSuccessClearXPieces: '成功清除{0}条{1}数据，失败{2}条，失败原因：',
  DataAdjustmentSame: '{0}调整前后数据一致，本次未进行任何更改',
  DataAdjustmentAgainConfirm: '已勾选业务{0}数据将被替换，是否确认？',
  SuccessfullyReplacedXPieces: '成功替换{0}条{1}数据',
  NotReplacedXPieces: '未找到符合条件的{0}，本次替换0条',
  PartSuccessReplacedXPieces: '成功替换{0}条{1}数据，失败{2}条，失败原因：',
  BusinessisNotPositiveOperation: '业务{0}不是正操作',
  BusinessisBlocked: '业务{0}已锁定',
  BusinessisHblLock: '业务{0}HBL已锁单',
  BusinessisInvalidLoadType: '业务{0}整拼类型不是委托拼箱',
  BusinessisContainerExist: '业务{0}已存在调整后的箱型箱种',
  BusinessPicecNotMatch: '业务{0}不存在原数据对应的箱型箱种',
  BusinessisMblHblContainerExist: '业务{0}已加入MBL拆并单/HBL拆并单/形式分单',
  BusinessisContainerSealNoExist: '业务{0}已填写箱封号',
  BusinessisTruckingContainerExist: '业务{0}已关联门点信息',
  BusinessisDischarginTruckingExist: '业务{0}已关联目的港派送',
  BusinessisAmsContainerExist: '业务{0}已关联反恐舱单',
  CopyFailedBusinessNumber: '一键复制失败业务编号',
  PackagingCategoryOfDangerousGoods: '危险品包装类别',
  CargoReleaseWay: '放货方式',
  WarehouseLoadingRemarks: '仓库内装备注',
  CheckStatuses: '勾选状态：',
  ClearStatuses: '清除勾选：',
  SelectAtLeastOneAdjustment: '请选择至少一项调整内容后再试！',
  ClearStateComfirm: '已勾选业务{0}勾选状态将被清除，是否确认？',
  CheckStateComfirm: '已勾选业务{0}勾选状态将被勾选，是否确认？',
  SuccessfullyCancelXPieces: '成功取消{0}条数据',
  SuccessfullyCheckXPieces: '成功勾选{0}条数据',
  PartSuccessClearXThePieces: '成功清除{0}条数据，失败{1}条，失败原因：',
  PartSuccessCheckXThePieces: '成功勾选{0}条数据，失败{1}条，失败原因：',
  BusinessisCargoDocLock: '业务{0}已锁单',
  DataCategoryProcessingFailed: '数据类别处理失败',
  PleaseSelectATemplate: '请选择模板',
  PleaseSelectANode: '请选择节点',
  PleaseSelectAState: '请选择状态',
  SuccessModifiedXBusinessState: '已成功修改{0}条业务状态',
  SuccessWithdraw: '已撤回{0}条',
  PleaseSpecificTemplateFilePreview: '请选择具体的模板文件，进行预览！！！',
  CopyLast: '抄录上次',
  WaybillNumberCopy: '单号抄录',
  CargoInformation: '货物信息',
  BillOfLadingQuantity: '提单件数',
  Packing: '包装',
  PleaseChoose: '--请选择--',
  CustomerType: '客户类型',
  HTSCode: 'HTS号码',
  EnglishCommodityName: '英文品名',
  TransportationInformation: '运输信息',
  MBLNumber: 'MB/L号码',
  HBLNumber: 'HB/L号码',
  CCNNumber: 'CCN号码',
  ShipName: '船名',
  ShipNumber: '船舶编号',
  PortArrivalDate: '到港日期',
  CountryOfOrigin: '原产国',
  BillLadingPlaceOfDispatch: '提单发货地',
  BillLadingPortOfDeparture: '提单起运港',
  BillLadingPortOfDischarge: '提单卸货港',
  BillLadingPlaceOfDelivery: '提单交货地',
  LastOverseasPort: '最后一个境外港口',
  HtsCode: '海关编码',
  FirstPortOfCall: '第一个停靠港',
  SynchronizeHBLInformation: '同步HBL信息',
  addHbl: '增加分单',
  NonVesselCarrierSCAC: '无船承运人SCAC',
  DeclarationAccount: '申报账户',
  DeclarationType: '申报类型',
  DirectToTheUnitedStates: '直达美国',
  ToTheInlandWarehouse: '到内陆仓库',
  TransferClearancePullToStates: '在加拿大中转，不清关，拉到美国',
  CargoThroughTheUnitedStates: '货物途径美国',
  ContainerInformation: '装箱信息',
  AddContainerInformation: '添加装箱信息',
  RemoveContainerInformation: '移除装箱信息',
  BoxSpecies: '箱种',
  BoxHeight: '箱高度',
  ContainerNumber: '箱号',
  SealNumber: '封号',
  CommodityName: '品名',
  PleaseEnterTheCommodityNameOrHSCode: '请输入品名或HS Code',
  ShippingCompanyContractNoRequired: '船公司约号不能为空',
  ApplicableRoutesNoRequired: '适用航线不能为空',
  ShippingCompanyNoRequired: '船公司不能为空',
  ValidityNoRequired: '有效期不能为空',
  ShippingCompanyAndBaseDifferent: '该约号适用船公司与基本页签所填信息不一致，请确认是否覆盖？',
  GiveUp: '放弃',
  BackFillToRoute: '该约号下维护了多个适用航线，请选择需要回填到基本页签的航线',
  MultipleApplicableRoutesDifferent: '该约号下维护了多个适用航线且均与基本页签已经输入的不一致．请选择需要回填到基本页签的航线',
  ApplicableRoutesDifferent: '该约号适用航线均与基本页签所填信息不一致，请确认是否覆盖？',
  ShippingCompanyDifferent: '你选择的船公司与已选约号的适用船公司不符，确认覆盖？<br/><span style=\'color:red\'>{0}</span>',
  AirlineDifferent: '你选择的港口归属航线与已选约号的适用航线不符，确认覆盖？<br/><span style=\'color:red\'>{0}</span>',
  EtdDifferentValidityPeriod: '你选择的ETD不符合约号有效期，确认覆盖？<br/><span style=\'color:red\'>{0}</span>',
  ValidityPeriodCannotCoverETD: '你选择的约号有效期无法覆盖ETD，确认覆盖？<br/><span style=\'color:red\'>{0}</span>',
  DoNotBackFill: '不回填',
  ValidPeriodMessage: '约号有效期：{0}',
  ValidPeriodEtdMessage: '约号有效期：{0}<br/> ETD:{1}',
  NumberApplicableToShippingCompany: '约号适用船公司：{0}',
  NumberApplicableToAirline: '约号适用航线：{0}',
  PleaseToDeleteTheContract: '您确定要删除选中的{0}个约号吗？此操作无法撤销。',
  ScNoIsUsed: '此约号已被使用，不能删除',
  ConfirmEnableTips: '激活后用户将可以在订单详情页面选择此约号，确认启用？',
  EnableTips: '只有当所有选中的约号都处于禁用状态时，才能进行激活操作',
  DisEnableTips: '禁用之后，该约号无法在订单详情中被选择，确定禁用？',
  ConfirmDisEnableTips: '只有当所有选中的约号都处于启用状态时，才能进行禁用操作',
  ContractRatePropertyRequired: '约价性质不能为空',
  NACRequired: 'NAC不能为空',
  CommodityNameRequired: '品名不能为空',
  ContractNumberRequired: '船公司约号已存在',
  PleaseSelectAirLine: '请选择航线（可多选）',
  PleaseInputNumber: '请输入数字',
  CargoInsuranceQuantityRequired: '舱保数量不能为空',
  CargoInsuranceUnitRequired: '舱保单位不能为空',
  BeginDateNotLessThanEndDate: '有效期开始不能大于有效期结束',
  SendingStatus: '发送状态',
  SendingStatusUpdateTime: '发送状态更新时间',
  CancellationStatus: '取消状态',
  Notifier: '通知人',
  SecondNotifier: '第二通知人',
  ShippingAndReceivingInformation: '收发通信息',
  ShipperName: '发货人名称',
  CompanyTitle: '抬头',
  Address: '地址',
  Phone: '电话',
  Optional: '非必填',
  ConsigneeName: '收货人名称',
  NotifierName: '通知人名称',
  SecondNotifierName: '第二通知人名称',
  BatchModifyDestinationPortInformation: '批量修改目的港信息',
  OverseasWarehouseNonAmazonWarehouse: '海外中转仓非亚马逊仓',
  SelectedBePositivePleaseSelect: '所选业务必须为正操作，请重新选择！',
  DomesticWarehouse: '国内仓',
  OverseasWarehouse: '国外仓',
  ContainerNumber2: '箱号：',
  ContainerNumberContainerNoNull: '箱号：containerNoNull',
  Exceeded: '已超出',
  CancelCustomsReturn: '取消退关',
  AttachmentContentTooLarge: '附件内容过大',
  LockedPleaseContactSupervisorUnlock: '已被锁定,不能打印,请联系上级主管解锁!',
  FCLProfitPrinting: '整箱利润打印',
  LCLProfitPrinting: '拼箱利润打印',
  DueToPrintOrUnlock: '由于信控超出,本票已被锁定,将不能打印或者EDI,请需要时联系上级解锁!',
  FeeName: '费用名称',
  BatchFeeScheme: '批量费用方案',
  NoCostCanBeTranscribed: '没有可抄录的成本.',
  ThisBeenSentEDIAllowed: '该舱单信息已发送过EDI,不允许删除.',
  TheVoidedAndCannotAgain: '该舱单已作废，不能再次作废。',
  ShanghaiManifestShippingCompany: '上海舱单 船公司：',
  NoResultsFound: '未查询到结果',
  ExportClearanceNewRegulation: '出口放行新规',
  ShanghaiAfterClearanceManifestContinuing: '上海海关172号令切换放行条件，凭“装载舱单”回执向码头传输海放信息，请客户报关完成后自行关注装载舱单状态，异常情况及时联系客服确认。届时，拼箱内冗余舱单未及时删除、落货不及时、放行后加拼不规范、舱单数据修改不成功、混拼、提单号在两年内重复使用都会影响装船。其次，装载舱单接收到正常回执后，如遇到任何预配舱单需要修改、删除或新增舱单的情况，需先联系船代删除装载舱单后继续操作。',
  YangshanDistrictNovember152021: '洋山关区：2021年11月15号',
  WaigaoqiaoDistrictNovember222021: '外港关区：2021年11月22号',
  GarbageManifest: '垃圾舱单',
  N1YourGoodsAreManifest: '1.垃圾舱单海关严令禁止！根据海关规定，每一票预配舱单，必须对应一票实际的出运货物。舱单发送后，如果您的货物未出运（未赶上船、出货计划变更等原因），该票舱单即视为垃圾舱单！',
  N2StowManifestMustSent: '2.垃圾舱单情况举例：船舶改配后，原预配舱单一定要删除，删除后才能发送新预配舱单！',
  N3OnTheFreightManifest: '3. 垃圾舱单未删除后果：不仅会影响装船，海关最高也可对货代施以50000元罚金并取消报关资格！出现垃圾舱单后，请及时联系客服协助删除垃圾舱单！',
  BusinessNotSelected: '未选择业务.',
  DoNotImportAndSend: '导入不发送',
  ViewReceipt: '查看回执',
  ImportEXCEL: '导入EXCEL',
  Receipt: '回执',
  ReceiptNumber: '回执编号',
  Time: '时间',
  PleaseSelectAccount: '请选择账户',
  MappingValueNotEmpty: '{0}不可为空，请在映射管理，为{0}配置映射代码',
  AfrFieldNotEmpty: '{0}不可为空',
  AfrEfreightDgTip: '危险品不可使用直接发送模式，请切换回间接发送。并去一飞补充危险品信息。',
  AfrFieldNotAccess: '不可超过{0}字符',
  CustomerNumberCannotBeEmpty: '【客户信息】AMS分单号不能为空.',
  CustomerNOCannotBeEmpty: '【客户信息】MB/L NO不能为空.',
  CustomerPortCannotBeEmpty: '【客户信息】卸货港不能为空.',
  CustomerDeliveryCannotBeEmpty: '【客户信息】交货地不能为空.',
  AMSNumber: 'AMS号码',
  AFRNumber: 'AFR号码',
  ACINumber: 'ACI号码',
  EManifestNumber: 'eManifest号码',
  SendSucceeded: '发送成功',
  NotSent: '未发送',
  ServiceChannel: '服务渠道',
  ExpectedAmazonWarehouseEntryTime: '预期入亚马逊仓时间',
  DestinationDeliveryMethod: '目的地配送方式',
  CourierCompany: '快递公司',
  TrackingNumber: '快递单号',
  POoriginalNumber: 'PO(原单号)',
  CustomsDeclarationMethod: '报关方式',
  CustomsClearanceMethod: '清关方式',
  EORIEnterpriseNumber: 'EORI企业号',
  VATTaxNumber: 'VAT/税号',
  VATRegistrationCountry: 'VAT注册国家',
  VATRegistrationAddress: 'VAT注册地址',
  VATCompanyEnglishName: 'VAT公司英文名',
  WithPower: '带电',
  WithMagnet: '带磁',
  Powder: '粉末',
  Liquid: '液体',
  EstimatedWarehouseEntrygoodArrivalTime: '预计入库/货好时间',
  RemoteWarehouse: '偏远仓',
  OceanFreight: '海运费',
  ServiceChannel2: '服务渠道：',
  FeeType: '费用类型：',
  EstimatedAmount: '预估金额：',
  Equivalent: '折合',
  FreightRateLevel: '运价级别：',
  BillingWeight: '计费重量：',
  CalculationMethod: '计算方式：',
  EstimatedTimeCannotBeEmpty: '预计入仓/货好时间不能为空！',
  DestinationCannotBeEmpty: '目的地不能为空！',
  DestinationCountryCannotBeEmpty: '目的国不能为空！',
  ZipCodeCannotBeEmpty: '邮编不能为空！',
  CannotBeEmpty: '不能为空！',
  PleaseTheConsignorUnitFirst: '请先选择委托单位。',
  DearAndThenCarryOperation: '亲，请先保存业务，再进行自动配货操作。',
  ClearanceMethod: '清关方式',
  EstimatedStorageReadyGoodsTime: '预计入库/货好时间',
  ForeignWarehouse: '国外仓',
  WithElectricity: '带电',
  WithMagnetism: '带磁',
  YourPieceWeightAndTo: '您的货物已参与过数据对比，自动装箱将会更新本票和所在主票的件毛体信息。',
  Prompt: '提示',
  GotIt: '知道了',
  DocumentNumber: '证件号码',
  Origin: '原产地',
  AreaCode: '区号',
  BoxAndCargoInformationFunction: '箱货信息不一致，请确认信息是否正确？可至基本页签修改箱货信息或通过【更新港区数据】功能匹配箱货信息。',
  InconsistencyBetweenPortAreaDataAndPackingInformationTips: '注意：港区数据与装箱信息不一致时，可能导致不推送预警提醒、SOP设置相关的提醒',
  TheComparisonFunctionToPossible: '已获取到最新的港区箱货信息，请尽快使用【更新港区数据】选择您想要的箱货数据',
  DetectionOfBasicTab: '检测到基本页签的',
  InconsistentThePortAreaReturn: '与港区返回的',
  PleaseTheOperationIsCorrect: '不一致',
  YouBoxAndCargoTab: '请立即到【装箱信息】查看。',
  BoxNum: '个箱子',
  GoCheck: '去查看。',
  BoxQuantity: '箱量',
  BoxModel: '箱型',
  CutOffDate: '截单日期',
  PortOpeningTime: '开港时间',
  PortOpeningDate: '开港日期',
  ScheduledBerthingTime: '计划靠泊时间',
  ScheduledDepartureTime: '计划离泊时间',
  ActualUnloadingTime: '实际卸船时间',
  ActualHeavyLiftingTime: '实际提重时间',
  ActualEmptyReturnTime: '实际还空时间',
  PleasePackingInformationToRemoved: '请选择需要移除的装箱信息！',
  BillOfLadingType: '提单类型',
  ArrivalDate: '到港日期',
  ShippingType: '发货类型',
  DischargingPort: '卸货港',
  DeliveryPlace: '交货地',
  CustomerShippingInformation: '客户发运信息',
  CargoReceiver: '货物接收方',
  Buyer: '买方',
  Modify: '修改',
  PleaseSelectABox: '请选中一个箱子',
  ReleaseOrderNumber: '放单号:',
  ExportReleaseNewRegulation: '出口放行新规',
  WechatPrompt: '请每个需要开通的用户至设置与工具-个人信息中，开启微信消息推送授权，并关注公众号。',
  YangshanAreaNovember152021: '洋山关区：2021年11月15号',
  WaigaoqiaoAreaNovember222021: '外港关区：2021年11月22号',
  GarbageCargoManifest: '垃圾舱单',
  N1ActuallyShippedIfGarbage: '1.垃圾舱单海关严令禁止！根据海关规定，每一票预配舱单，必须对应一票实际的出运货物。舱单发送后，如果您的货物未出运（未赶上船、出货计划变更等原因），该票舱单即视为垃圾舱单！',
  N2ManifestMustBeDeletion: '2.垃圾舱单情况举例：船舶改配后，原预配舱单一定要删除，删除后才能发送新预配舱单！',
  N3YuanOnTheManifest: '3. 垃圾舱单未删除后果：不仅会影响装船，海关最高也可对货代施以50000元罚金并取消报关资格！出现垃圾舱单后，请及时联系客服协助删除垃圾舱单！',
  DetailsOfSeaExportGoods: '海运出口货物明细',
  PleaseSelectTheSpecifiedData: '请选择指定数据',
  LicenseOfLadingNumberEmpty: '车牌号和提单号不能为空',
  NoRelevantInformation: '暂无相关信息',
  EstimatedDeliveryTime: '预计送达时间',
  ActualDeliveryTime: '实际送达时间',
  ObtainedContainerAndGoodsData: '您输入的船名航次',
  Sailing: '航次：',
  WithBookingTab: '跟港区获取的船名航次',
  InconsistentFromTheBillData: '不一致，是否导入港区获取的船名航次并清空以获取的船期数据？',
  InconsistentFromTheBillDataTips: '注意：若是船名航次不正确可能导致获取到对应不正确的船期时间（计划离靠泊时间、开截港时间、实际离靠泊时间）',
  TheTicketIsNotImport: '该票MBL对单状态不是未开始，无法导入。',
  Correction: '更正',
  ThisItIs1Again: '该job {0} 已成功发送过EDI订舱，<br>此次发送是{1}-{2}，<br>请确认是否需要再次发送？',
  PleaseOnePieceOfData: '请选择一条数据！',
  BatchImport: '批量导入',
  GoodsInformationImport: '货物信息导入',
  SeaFreight: '海运费',
  AirFreight: '空运费',
  Freight: '运费',
  BatchCostScheme: '批量费用方案',
  Shanghai: '上海',
  Qingdao: '青岛',
  SeaguardianSupportsSM2WeighingMethod: '海管家通道仅支持SM2称重方式。',
  ContainerNumberSealNumber: '箱号-封号',
  DueCannotBePrintedNeeded: '由于信控超出,本票已被锁定,将不能打印或者EDI,请需要时联系上级解锁!',
  LockedContactTheSuperiorUnlock: '已被锁定,不能打印,请联系上级主管解锁!',
  ModificationSuccessful: '修改成功',
  StatusConversionSuccessful: '状态转换成功.',
  NoDeclarationFormCreated: '未创建报关单',
  Cleared: '已收齐',
  Uncleared: '未收齐',
  SentOut: '已送出',
  TakenOver: '已接单',
  Filed: '已归档',
  TaxRefunded: '已退税',
  ReturnedbyOurCompany: '已取回(我司)',
  ReturnedtoTheCustomer: '已退还(客户)',
  WithdrawalOfDocumentStatus: '单证状态撤回',
  DocumentStatus: '单证状态',
  SendOut: '送出',
  Archive: '归档',
  RefundTax: '退税',
  RetrieveourCompany: '取回(我司)',
  Returncustomer: '退还(客户)',
  StateNotSelected: '未选择状态.',
  DateNotSelected: '未选择日期.',
  WithdrawalSuccessful: '回撤成功.',
  NoDataSelected: '未选择数据.',
  PleaseANewDeclarationForm: '请新建报关单.',
  NoDataModified: '没有数据被修改',
  SavedSuccessfully: '保存成功.',
  BatchIsInconsistentPleaseSelect: '批量打印状态不一致，请重新选择.',
  NoDataAvailableForPrinting: '没有数据可打印.',
  Document: '单证',
  Date: '日期',
  NoFilesAvailable: '没有文件可',
  Takeover: '接单',
  Retrieve: '取回',
  FileNotSelected: '文件未选择.',
  NoTemplateFound: '没有找到',
  ForTheCorrespondingPrint: '对应的打印模板',
  BookingAPI: '订舱API',
  BillOfLadingAPI: '提单API',
  PleaseTheBusinessToSend: '请选择要发送的业务！',
  ContainerQuantity: '箱数量',
  BookingEdiSendingChannel: '订舱EDI通道',
  BookingEdiSendingTime: '订舱EDI时间',
  EdiStateQuery: 'EDI状态查询',
  JiLianStar: '吉联新',
  NotBeSent: '(注：此行不发送)',
  FullyStored: '完全入库',
  CancelFullWarehousing: '取消完全入库',
  StoredTipOne: '业务编号{0}的进仓单共{1}单',
  StoredTipTwo: '确认操作{0}？',
  StoredTipThree: '请选择入库状态为【{0}】的数据',
  StoredTipFour: '该票业务的进仓单已经完全入库！',
  SelectedRightData: '请选择符合条件的数据',
  EmptyContainerNotificationTime: '空柜通知时间',
  WaitBookingVerifyBatch: '批量审核中，请稍等，审核成功后会提醒您。',
  BookingVerifyBatch: '批量审核业务不能超过500条！',
  Roles: '角色',
  ZipForCountry: 'US,CA 必填',
  PleaseZipForSend: '请选择邮编发送!',
  BL_EDI_SendChannel: '提单EDI发送通道',
  BL_EDI_SendTime: '提单EDI发送时间',
  VGM_EDI_SendChannel: 'VGM EDI发送通道',
  VGM_EDI_EDISendTime: 'VGM EDI发送时间',
  CleanManifest_EDI_SendChannel: '清洁舱单EDI发送通道',
  CleanManifest_EDI_SendTime: '清洁舱单EDI发送时间',
  Way99_EDI_SendChannel: '99路提箱单EDI发送通道',
  Way99_EDI_SendTime: '99路提箱单EDI发送时间',
  AMS_EDI_SendChannel: 'AMS EDI发送通道',
  AFR_EDI_SendChannel: 'AFR EDI发送通道',
  ACI_EDI_SendChannel: 'ACI EDI发送通道(CW)',
  ACI_EDI_SendTime: 'ACI EDI发送时间(CW)',
  AMS_JS_STATE: 'AMS发送状态',
  ACI_JS_STATE: 'ACI发送状态',
  AFR_JS_STATE: 'AFR发送状态',
  AMS_EDI_SendTime: 'AMS EDI发送时间',
  AHR_EDI_SendTime: 'AHR EDI发送时间',
  ENS_EDI_SendTime: 'ENS发送时间',
  PreShippingBill_EDI_SendChannel: '预配舱单EDI发送通道',
  PreShippingBill_EDI_SendTime: '预配舱单EDI发送时间',
  OverseaAgent_EDI_SendChannel: '海外代理EDI发送通道',
  OverseaAgent_EDI_SendTime: '海外代理EDI发送时间',
  PortOfHubSecond: 'HUB港-二程',
  PortOfHubThird: 'HUB港-三程',
  ProvisioningStatus: '预配状态',
  ArrivalInformation: '到港信息',
  QuantityConsign: '件数（委）',
  QuantityActual: '件数（实）',
  WeightConsign: '毛重（委）',
  WeightActual: '毛重（实）',
  CubageConsign: '体积（委）',
  CubageActual: '体积（实）',
  VolumetricWeightConsign: '材积（委）',
  VolumetricWeightActual: '材积（实）',
  ChargeWeightConsign: '计费重量（委）',
  ChargeWeightActual: '计费重量（实）',
  CategoryOfGoodsName: '货物大类名称',
  ShipperLine2: '发货人第二行',
  ConsigneeLine2: '收货人第二行',
  NotifyPartyLine2: '通知人第二行',
  ShipperLine3: '发货人第三行',
  ConsigneeLine3: '收货人第三行',
  NotifyPartyLine3: '通知人第三行',
  ShipperLine4: '发货人第四行',
  ConsigneeLine4: '收货人第四行',
  NotifyPartyLine4: '通知人第四行',
  ShipperLine5: '发货人第五行',
  ConsigneeLine5: '收货人第五行',
  NotifyPartyLine5: '通知人第五行',
  ShipperLine6: '发货人第六行',
  ConsigneeLine6: '收货人第六行',
  NotifyPartyLine6: '通知人第六行',
  ShipperLine7: '发货人第七行',
  ConsigneeLine7: '收货人第七行',
  NotifyPartyLine7: '通知人第七行',
  OperationLog: '操作日志',
  DimensionLength: '尺寸CM(长)',
  DimensionWidth: '尺寸CM(宽)',
  DimensionHeight: '尺寸CM(高)',
  SystemAdd: '平台新增',
  FreeContainerEndTime: '免柜到期时间',
  FreeStorageEndTime: '免堆到期时间',
  QuantityConsign2: '件数（委托）',
  QuantityBooking: '件数（订舱）',
  QuantityActual2: '件数（实际）',
  QuantityDocumentation: '件数（制单）',
  WeightConsign2: '毛重KGS（委托）',
  WeightBooking: '毛重KGS（订舱）',
  WeightActual2: '毛重KGS（实际）',
  WeightDocumentation: '毛重KGS（制单）',
  CubageConsign2: '体积CBM（委托）',
  CubageBooking: '体积CBM（订舱）',
  CubageActual2: '体积CBM（实际）',
  CubageDocumentation: '体积CBM（制单）',
  ChargeWeightConsign2: '计费重量M/T（委托）',
  ChargeWeightBooking: '计费重量M/T（订舱）',
  ChargeWeightActual2: '计费重量M/T（实际）',
  ChargeWeightDocumentation: '计费重量M/T（制单）',
  DensityConsign: '密度kg/m³（委托）',
  DensityBooking: '密度kg/m³（订舱）',
  DensityActual: '密度kg/m³（实际）',
  DensityDocumentation: '密度kg/m³（制单）',
  ConsignationCompany2: '委托单位/实际通知人',
  ConsignationCompanyHeader2: '委托单位抬头/实际通知人抬头',
  WarehouseSupplier2: '仓库供应商/仓库',
  ShipperDetail: '发货人详情',
  ConsigneeDetail: '收货人详情',
  NotifyDetail: '通知人详情',
  MasterBillNo2: '主单号/MBL',
  SynchroniseBooking: '同步订舱信息',
  HBLNoRepeat: '存在HB/L NO重复，单号："{0}"',
  ConfirmSynchronizeHBL: '使用Synchronise HBL时会清空，手工新增录入的信息。是否继续？',
  GetFiles: '获取文件',
  UploadCustomerFiles: '上传客户件',
  CustomerSelfIssuedFiles: '客户自出单文件',
  CheckTheBLLog: '对单日志',
  Surrendered: '电放放单',
  InterfaceName: '接口名称',
  DataFlowDirection: '数据流向',
  CheckTheBLCenterApiLog: '对单中心日志',
  PleaseMaintainTheCorresponding: '请维护对应的{0}人员',
  PleaseMaintainThePhoneNumberOfTheCorrespondingPersonnel: '请维护对应人员的手机号',
  XhqCsrMsg: '信号旗客服留言',
  copyLink: '复制链接',
  openLink: '打开链接',
  BillNotCfm: '提单未确认，请先确认',
  ATDIsNull: '尚未离港，请离港后电放放单。',
  BillNotRelease: '提单放单状态，不是"可放单"',
  CfmBillFirst: '尚未有，请先点击"确认对单"',
  IsReleased: '已放单，不可在此处操作再上传客户稿件',
  IsReleased2: '已放单，不用重复操作',
  UnStartOrUnConfirmCanUpload: '在提单【未开始】或【未确认】状态时才可上传文件',
  LinkIsNull: '链接为空',
  OnlySurrenderedSupport: '仅“SURRENDERED”提单方式，支持电放放单',
  SynchronizePackingInfo: '同步更新装箱信息',
  ManifestNotConfirmed: '舱单未确认!',
  AreYouSureSynchronizePackingInfo: '确定要同步更新装箱信息吗？',
  NoDataSynced: '未同步任何数据，请确认箱型箱种~',
  VirtualBillType: '形式分单种类',
  DestinationPortAgentIsNotEqualToDesignatedFreightAgent: '目的港代理不等于指定货代理',
  MultipleCustomsDeclarationInaccurate: '存在1个Job多个报关委托的场景，数据会不准确。请线下联系报关行通知报关详细数据。',
  OnlySupportOneCustomsDeclaration: '该功能仅适用于1个业务中仅创建1个报关委托场景。',
  OnlySupportOneCustomsCommission: '请单选一条报关委托，请求校验稿。',
  hblRefNo: 'hbl拆单Ref',
  HBLRefNo2: 'HBL Ref No. ',
  BatchPushCharges: '批量推送费用(交叉委托)',
  ChargeConfirmed: '待确认费用',
  ViewReception: '查看接收',
  ViewSending: '查看发送',
  branchTransactions: '分公司往来',
  OurJobNo: '我方业务编号',
  TheirJobNo: '对方业务编号',
  firstSendTime: '首次发送时间',
  ConfirmReceiveTheseCharges: '确认接收这些费用？',
  AuditOperator: '审核操作人',
  Dimensions: '尺寸规格 (长*宽*高 单位M)',
  DoorRemarks: '附加说明',
  BillOfLadingDesignatedFreightAgentFeedback: '提单-指定货代理反馈',
  ChangeValue: '修改值',
  AcceptChange: '接受修改',
  Rejected: '不接受',
  AgentFeedbackRemarks1: '指定货代理线上修改意见已被接受',
  AgentFeedbackRemarks2: '指定货代理线上修改意见已驳回,',
  AgentFeedbackRemarks3: '请线下,与发货人和指定货代理确认最终修改内容',
  AgentEmailSend: '指定货代理邮件对单发送',
  ETAFirstPortOfCall: '第一个停靠港停靠日期',
  ETAFirstPortOfCallNotNull: 'on-board模式下，"ETA First Port of Call" 不能为空',
  DocumentOffice: '单证公司',
  CustomerOffice: '客服公司',
  PleaseReferToTheEmailForSpecificErrorInformation: '详见邮件报错具体信息',
  AMSDeleteTips: '该AMS No未在系统中发送成功过AMS，无法进行删除',
  MultipleMode: '多单模式',
  NumberExchange: '单号互换',
  ReturnMode: '返回一单模式',
  OcrTip: '*提示：可在”基本配置-单据识别设置“，设置额外显示的录单字段。',
  OcrOtherInfo: '其它录单信息：',
  DocumentRecognitionSettings: '单据识别设置',
  SeOcr: '海运出口托书识别',
  ocrOtherField: '请选择额外录单字段',
  ocrTextMapper: '识别文字映射',
  IdentifyingText: '识别文字',
  mappedValue: '映射值',
  addMapper: '新增映射',
  editMapper: '编辑映射',
  supplierCharge: '供应商费用',
  supplierOrderNo: '供应商单号',
  supplierName: '供应商名称',
  supplierMatchName: '供应商匹配名称',
  chargeItemLocal: '本地费用名称',
  refMsg1: '参考信息（一）',
  refMsg2: '参考信息（二）',
  supportNo: '辅助单号',
  pushTime: '推送时间',
  confirmCharge: '确认费用',
  selectBeConfirmedCharge: '请选择待确认费用',
  RefreshSuccessfulRows: '刷新成功{0}条',
  SupplierFeesToBeProcessed: '条供应商费用待处理',
  ReceivingBranch: '接收分公司',
  ReceivingMatchBranch: '接收分公司匹配名称',
  PleaseRefreshThePage: '找不到映射代码，请维护映射。 如已维护请刷新。',
  BusinessDateIsNull: '业务对应的业务日期为空',
  NoJobMatch: '没有匹配的业务,请刷新',
  ReleaseGoodsJY: '放货JY',
  ReleaseJY: '放单JY',
  TakeContainerJY: '提箱JY',
  ContainerPreloadJY: '装箱JY',
  CancelContainerPreloadJY: '取消装箱JY',
  ReleaseGoodsPhotos: '放货照片',
  ReleaseGoodsStatus: '放货状态',
  NoticeTime: '通知时间',
  ReleaseGoods: '放货',
  warehouseNoNotNull: '进仓编号不能为空',
  warehouseNotNull: '仓库名称不能为空,请在基本页签选择仓库或者仓库供应商',
  consignerNotNull: '委托人不能为空',
  ReleaseRemarks: '放单备注',
  RequireDate: '要求日期',
  TakeContRemarks: '提箱备注',
  ConfirmSendPackingInstructions: '确定发送装箱指令?',
  AlreadySentReleaseGoods: '已发送放单，请勿多次推送',
  PleaseSelectWarehouseNo: '请选择进仓编号',
  TheWarehouseNoHasBeenReleased: '进仓编号曾经发送过，是否仍然发送？',
  ViewReleaseGoodsPhotos: '查看放货照片',
  JyWarehouseInterfaceLog: '精谕仓库对接日志',
  JyWarehouseApiLog: '精谕仓库接口日志',
  LclDynamic: '拼箱动态',
  TakeContainerNotice: '提箱通知',
  TakeContainerDone: '提箱完成',
  PreloadContainerOrder: '装箱指令',
  PreloadContainerDone: '装箱完成',
  SendPort: '送港派车',
  SendPortStart: '送港发车',
  ArrivalPort: '进港(仓库上报)',
  ExistEmptyContainer: '勾选的箱子内存在装箱信息为空的箱子',
  docLink: '对单链接',
  Field: '字段',
  ErrorDescription: '错误说明',
  VerificationPrompt: '验证提示',
  InformationSavingOnly: '仅保存信息',
  Required: '必填',
  InputTwoAbove: '请输入两位以上',
  SendError: '发送失败',
  CounterTerrorismManifestConfiguration: '反恐舱单配置',
  AfrAccount: 'AFR账户',
  AfrPassword: 'AFR密码',
  ApplicantEORI: '申报人EORI',
  AccountIsNotNull: '请选择发送的账号',
  PasswordIsNotNull: '请维护发送的密码',
  Notification: '通知',
  Error: '错误信息',
  NoSendingRecord: '暂无发送记录',
  GetExceptions: '获取异常',
  WaitingReceipt: '存在同一个船名航次同一个Nvocc SCAC暂未获取到海关回执，无法发送，请耐心等待',
  NotOperable: '存在未获取到回执或者未发送成功的，无法发送原始、更正、删除',
  AmsVgm: '舱单/VGM',
  AmsReceipt: 'AMS回执',
  AciReceipt: 'ACI回执',
  AfrReceipt: 'AFR回执',
  VgmReceipt: 'VGM回执',
  EnsReceipt: 'ENS回执',
  ManifestReceipt: '预配舱单回执',
  UserDefinedRole1: '自定义岗位1',
  UserDefinedRole2: '自定义岗位2',
  AmsReceiptRemind: '反恐舱单回执提醒',
  DangerousCargoCode: '货物类型-危险品',
  CustomerToOrder: '客户对单',
  DesignatedGoodsToBillOfLading: '指定货对单',
  OverwriteOriginalRemark: '覆盖原【远程订舱的备注】',
  DownloadPortServiceScope: '下载港口服务范围',
  AllowSaleProduct: '可售卖产品',
  FullOrInside: '全程/国内',
  Commissioned: '已委托',
  weightVolumeBillWeightConsolidated: '包含并单的重量/体积/计费重量',
  weightVolumeBillWeightConsolidatedTip: '所选业务存在并单，会统计并单的重量/体积/计费重量。默认统计基本页签的重量/体积/计费重量。',
  AttentionForSynchronizedContainer: '注意：当填写箱号时，本次设置生效。如未填写，则不生效。',
  BatchFillGpExplain: '批量填写GP说明',
  AiDocRecognition: 'AI单证识别',
  AiRecognition: 'AI识别',
  SupportMultipleFiles: '支持识别货代提单、提单确认件、托书等等多种文件！',
  DragOrClick: '拖拽文件到此处，或',
  ClickUpload: '点击上传',
  FileSizeLimit: '每次只能上传一个文件，单个文件不超过4MB',
  InvalidFileType: '文件类型不正确',
  FileTooLarge: '文件大小不能超过4MB',
  Reupload: '重新上传',
  StartRecognition: '开始识别',
  RecognitionInProgress: '识别中...请稍后，大约需要30s',
  RecognitionTextTip: '请直接复制粘贴内容后点击识别按钮，系统将会自动识别并填充内容到对应字段中',
  EstimatedTime: '预计需要{time}',
  RecognitionSuccess: '识别成功',
  RecognitionFailed: '识别失败',
  AiRecognitionWarn: 'AI识别可能存在误差，发送前请仔细核对',
  SupportsShanghaiPortShipAgent: '只支持查看上海港对应的船代',
  ServiceNotActivated: '您未开通此项服务',
  updateOrderContent: '更新订单内容',
  CheckCustomsBrokerComfirm: '已选择了【报关行】，将批量更新对应业务的【报关行】字段，是否确认？',
  CheckCustomsBrokerComfirm2: '已选择了【报关服务】但未选择【报关行】，将批量清空业务的【报关行】字段，是否确认？',
  ClearCustomsBrokerComfirm: '已勾选清除业务本地服务【报关】，并批量清空已选业务的【报关行】字段，是否确认？',
  EdiEuBolInfo: '欧线提单补充信息',
  EuroLineENSDeclaration: '欧线ENS申报标识',
  SelectEuroLineENSDeclaration: '请选择"欧线ENS申报标识"',
  ManifestType: '舱单类型',
  SelectManifestType: '请选择舱单类型',
  SupplementaryDeclarant: '补充申报人',
  ChemicalIdentifier: '化工品标识',
  ChemicalProduct: '化工品',
  NonChemicalProduct: '非化工品',
  ChemicalCUSCODE: '化工品CUS CODE',
  PostalInformation: '邮政信息',
  PostalInformation2: '邮政信息<br>(与街道名称、号码二选一)',
  EORICode: 'EORI代码',
  ShipperStreetNumber: '发货人街道号码',
  ShipperStreetName: '发货人街道名称',
  ActualShipperStreetNumber: '实际发货人街道号码',
  ActualShipperStreetName: '实际发货人街道名称',
  ShipperZipCode: '发货人邮编',
  ShipperAddress: '发货人地址',
  ConsigneeStreetNumber: '收货人街道号码',
  ConsigneeStreetName: '收货人街道名称',
  ActualConsigneeStreetNumber: '实际收货人街道号码',
  ActualConsigneeStreetName: '实际收货人街道名称',
  ConsigneeZipCode: '收货人邮编',
  ConsigneeAddress: '收货人地址',
  NotifyStreetNumber: '通知人街道号码',
  NotifyStreetName: '通知人街道名称',
  NotifyZipCode: '通知人邮编',
  ActualShipper: '实际发货人',
  ActualShipperName: '实际发货人名称',
  ActualConsignee: '实际收货人',
  ActualConsigneeName: '实际收货人名称',
  ByBillingDate: '按账单生成日期',
  ByBusinessDate: '按业务日期',
  CostRateValue: '费用汇率取值',
  CopyBusiness: '抄录业务',
  CopyActualShipper: '抄录发货人',
  CopyActualConsignee: '抄录收货人',
  SelectEORICode: '请输入{0}栏位的EORI代码信息',
  TOOrderRequired: 'TO Order需要提供',
  EORICodeExample: '代码类型+代码编号',
  PlsInputParameter: '请输入{0}',
  PlsSelectUnLCL: '请选择整拼类型为非自拼箱的业务',
  StreetInfo: '街道号码、街道名称或者邮政信息',
  ImportingLater: '正在导入，请稍后操作',
  BusinessSeq: '业务序号',
  Yard: '场站',
  PleaseSelectCarrier: '请选择提单号对应的承运人',
  ModifyStatus: '修改状态',
  ModifyManifestStatusTip: '只支持发送过舱单的关单号修改状态',
  AllSoNos: '所有关单号',
  PlsSelectSoNo: '请选择需要修改的关单号',
  FclOrderType: 'FCL订单明细',
  LclOrderType: 'BC订单明细',
  ConsoleOrderType: '非进仓订单明细',
  CopyBusinessSendConsigneeNotify: '抄录业务收发通',
  DeclarationInformation: '申报信息',
  RelatedInformation: '关联方信息',
  SubstratumDeclarant: '下层申报人',
  PortInformation: '港口信息',
  BuyerName: '买方名称',
  BuyerAddress: '买方地址',
  BuyerEORICode: '买方EORI代码',
  BuyerPostalCode: '买方邮编',
  BuyerCountry: '买方国家',
  BuyerCity: '买方城市',
  SellerName: '卖方名称',
  SellerAddress: '卖方地址',
  SellerEORICode: '卖方EORI代码',
  SellerPostalCode: '卖方邮编',
  SellerCountry: '卖方国家',
  SellerCity: '卖方城市',
  UCRNO: 'UCR NO',
  ShipperEORI: '发货人EORI',
  ConsigneeEORI: '收货人EORI',
  NotifyEORI: '通知人EORI',
  FactoryEORI: '工厂EORI',
  WarehouseEORI: '仓库EORI',
  LCLPersonEORI: '拼箱人EORI',
  ActualShipperCountry: '发货人国家',
  ActualShipperCity: '发货人城市',
  ActualRecipientCountry: '收货人国家',
  ActualRecipientCity: '收货人城市',
  NotifyPhone: '通知人电话',
  NotificationCountry: '通知人国家',
  NotifyPersonCity: '通知人城市',
  BuyerStreetNumber: '买方街道号码',
  BuyerStreetName: '买方街道名称',
  SellerStreetNumber: '卖方街道号码',
  SellerStreetName: '卖方街道名称',
  CopyActualRecipient: '抄录实际收货人',
  CopyActualShip: '抄录实际发货人',
  LinkSendAmsError: '发送中不允许再次发送',
  DangerousCode: '危险品代码',
  PleaseEnterHeader: '请输入抬头',
  PleaseEnterAddress: '请输入地址1',
  PleaseEnterAddress2: '请输入地址2',
  PleaseSelectCountry: '请选择国家',
  PhoneFormat: '只允许输入数字',
  PleaseEnterState: '请输入州/省',
  PleaseEnterCity: '请输入城市',
  PleaseEnterPostalCode: '请输入邮编',
  PleaseEnterMbl: '请填写不包含SCAC CODE的主单号信息',
  VesselCallSignCheck: '只能填写1-9位大写字母和数字',
  MarksFormat: '只能输入大写小写字母，数字，短横杠，斜杠，逗号，空格，冒号，引号，加号，下划线',
  MustBe3: '必须为3个字符',
  OneCargoInfo: '只需添加一条合计的货物信息',
  Instructions: '原因具体说明',
  ExplanationRequired: '选择\'other\'其他原因必填',
  ConfirmDeletion: '确定删除',
  HblCheck: '只允许使用大写字母、数字、连字符和斜线',
  MustBe2: '必须为2个字符',
  MustBe11: '必须是11个字符，字母数字，第4个字符必须是U',
  MustBeU: '第四个字符必须是U',
  MustBe4: '必须为4个字符',
  VesselNotNull: '请在订舱页签输入船名',
  VoyageNotNull: '请在订舱页签输入航次',
  EtaNotNull: '请在基本页签签输入ETA',
  StreetName: '街道名称',
  ExampleIllustrateEORI: '举例说明EORI12828',
  CycleTwoHundredTimesNotUseMbl: '已顺延200次，未找到可使用的关单',
  GenerateMblButLessThan: '已生成【{0}】条，剩余无可使用的关单号',
  selectedRowCount: '已选择：{0} 项',
  specialOperationCode: '特殊操作代码',
  doubleClickToAddSpecialOperationCode: '双击添加特殊操作代码',
  selectSpecialOperationCode: '双击选择特殊操作代码',
  selectOperationRequirement: '双击选择操作要求',
  TransshipmentTransportationMethod: '转运方式',
  specialHandlingCodes: '特殊操作码',
  AddApproximateSymbolToItemColumn: '添加约号到品名栏',
  BusinessLockedStatus: '业务锁定状态',
  ImportChargeAllBusiness: '当一个业务编号同时存在于多个业务类型中时全部处理，即编号在海出和海进中都存在，则同时导入海出和海进业务中。',
  OriginBillOfLading: '正本提单',
  ShippingOrder: '托书文件',
  EmptyOut: '提空箱（Empty Out）',
  GateIn: '集装箱进港时间（Gate in）',
  VesselDeparturePOL: '船舶离港（Vessel Departure POL）',
  SendAll: '一次性发送所有',
  PendingPickingOrder: '待拣货订单',
  PickingList: '拣货单',
  WarehouseReleaseReceipt: '出仓单',
  QuickSearchMBL: '快捷检索:主单号',
  QuickSearchPickingOrderNo: '快捷检索:拣货单号',
  DeliveryStation: '交货货站',
  AssemblyPlanNumber: '拼装计划单号',
  FlightDateRange: '航班日期范围',
  OutboundInstruction: '是否有出仓指令',
  WarehouseEntryNumber: '入仓单号',
  BoardNumber: '板纸号',
  GenerateAPickingList: '生成拣货单',
  GenerateAndIssueOrders: '生成并出单',
  PickingOrderNumber: '拣货单号',
  PickingStatus: '拣货状态',
  ThisPickingOrderNoIs: '本次拣货单号为:',
  SuccessfullyGenerated: '生成成功',
  CloseAndCopyPickingOrderNo: '关闭并复制拣货单号',
  PleaseCheckSameDataWareHouse: '不同仓库的货物，不能在一个拣货单上',
  DifferentGoodsCannotSamePickingList: '不同的交货货站的货物，不能在一个拣货单上',
  PickingCompleted: '拣货完成',
  CancelPickingCompleted: '取消拣货完成',
  OutboundStatus: '出仓状态',
  OutboundConfirmation: '出仓确认',
  CancelWarehouseConfirmation: '取消出仓确认',
  WarehouseConfirmationSuccessful: '出仓确认成功',
  CancelWarehouseConfirmationSuccessfully: '取消出仓确认成功',
  PleaseSelectCorrespondPickingList: '请单独勾选对应的拣货单',
  PleaseCheckDataPickingCompletionUnOutBound: '请勾选拣货完成且未出仓的数据',
  PleaseCheckDataPickingCompletionOutBound: '请勾选拣货完成且已出仓的数据',
  NotAllowEditPickingCompletion: '拣货完成的数据不允许编辑',
  NotAllowDeletePickingCompletion: '拣货完成的数据不允许删除',
  PleaseCheckDataRemoved: '请勾选需要移除的数据',
  KeepLeastOneDetail: '至少保留一条明细',
  CargoVehicle: '揽货车辆',
  OutboundRemarks: '出仓备注',
  DeliveryTime3: '收货时间',
  OutboundUser: '出库人',
  operationTrajectory: '运行轨迹',
  pickupEmptyContainer: '出发提柜',
  arrivalFactory: '到厂',
  departureFactory: '离厂',
  enterTerminal: '进码头',
  customsRelease: '海关放行',
  terminalRelease: '码头放行',
  loadedOnVessel: '上船',
  departurePort: '离港',
  arrivalPort: '到港',
  destinationCustomsClearance: '目的港放关',
  deliveryGoods: '送货',
  returnContainer: '还箱',
  driver: '司机',
  contactInfo: '联系方式',
  licensePlate: '车牌号',
  jobNumber: '业务编号',
  vesselVoyage: '船名航次',
  customsDeclarationNo: '关单号',
  sailingDate: '开航日期',
  closingTime: '截关时间',
  QueryThreeMonths: '注：查询数据为三个月内数据',
  WarehouseEntrySerialNumber: '入仓流水号',
  PreWarehouseNumberOfPackages: '前置仓件数',
  PreWarehouseGrossWeight: '前置仓毛重',
  PreWarehouseVolume: '前置仓体积',
  PreWarehouseChargeableWeight: '前置仓计费重',
  CargoTerminalNumberOfPackages: '货站件数',
  CargoTerminalGrossWeight: '货站毛重',
  CargoTerminalVolume: '货站体积',
  CargoTerminalChargeableWeight: '货站计费重',
  DocumentationChargeableWeight: '制单计费重',
  SignedDocumentNumberOfPackages: '签单件数',
  SignedDocumentGrossWeight: '签单毛重',
  SignedDocumentVolume: '签单体积',
  SignedDocumentChargeableWeight: '签单计费重',
  DeadlineForDeclaringHazards: '截危申报时间',
  BookingManagementListPage: '舱位管理列表页',
  PrintByFleet: '按车队打印',
  BoxContents: '箱货明细',
  BatchAssignMasterOrderNumbers: '批量分配主单号',
  PleaseForThePositiveAssign: '请选择正操作的业务进行分配',
  SuccessfullyItemsFailed1Items: '已成功分配{0}条，失败{1}条！',
  ReasonForFailure: '失败原因：',
  MBLNOAlreadyExists: '已存在MB/L NO',
  NonOperational: '非正操作',
  UnableTheMainTrackingNumber: '未匹配到主单号',
  WarehouseEntryInformation: '进仓信息',
  NumberOfItemsReceived: '进仓件数',
  GrossWeightUponEntry: '进仓毛重',
  WarehouseVolume: '进仓体积'
}
